// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:16:28.513Z
// Property: Falls at Spring Creek (ID: 6737460151191759)
// Collections: 48 amenities, 16 floorplans (live), 54 photos, 74 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191759",
  "property_external_id": "4857247",
  "property_zillow_url": "https://www.zillow.com/homedetails/1900-Wesleyan-Dr-Macon-GA-31210/2089490910_zpid/",
  "property_apartments_url": "https://www.apartments.com/falls-at-spring-creek-macon-ga/vhwt12e",
  "property_google_business_url": "https://www.google.com/maps/place/Falls+at+Spring+Creek/data=!4m2!3m1!1s0x0:0x34b504ec7d9ca708?sa=X&ved=2ahUKEwjrnN3DubySAxX0mWoFHSNEPXoQ_BJ6BAgoEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321147659",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "falls-at-spring-creek",
  "property_name": "Falls at Spring Creek",
  "property_website_url": "https://www.fallsatspringcreek.com/",
  "property_domain": "https://www.fallsatspringcreek.com/",
  "property_address": "1900 Wesleyan Dr",
  "property_full_address": "1900 Wesleyan Dr, Macon, GA 31210",
  "property_address_1": "1900 Wesleyan Dr",
  "property_address_2": null,
  "property_address_city": "Macon",
  "property_address_state": "GA",
  "property_address_zip_full": "31210-8807",
  "property_address_zip": "31210",
  "property_address_country": "US",
  "property_address_county": "Bibb County",
  "property_neighborhood_address": "Bibb County",
  "property_address_latitude": "32.9296445",
  "property_address_longitude": "-83.7198114",
  "property_email": "fallsspringcreek@rreafresidential.com",
  "property_phone": "(478) 474-7537",
  "property_call_tracking_phone": "478-606-1492",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Nestled in the heart of Macon, GA, Falls at Spring Creek offers spacious one, two, and three-bedroom floor plans designed for your comfort. Enjoy resort-style amenities like a refreshing pool, modern fitness center, and inviting clubhouse. Experience vibrant community living—connect with neighbors and find your perfect home today!",
  "property_long_description": "Welcome to Falls at Spring Creek, an inviting apartment community nestled in the heart of Macon, GA, offering an exceptional living experience for everyone. With thoughtfully designed floor plans ranging from one to three bedrooms, our spacious apartments cater to a variety of lifestyles, ensuring comfort and convenience at every turn. \n\nAt Falls at Spring Creek, you can indulge in a wealth of amenities designed to enhance your lifestyle. Dive into our sparkling pool, keep fit in our well-equipped fitness center, or enjoy a friendly match at our tennis and volleyball courts. Our community also features a playground, sundeck, and barbecue grills for outdoor gatherings, making it the perfect place for relaxation and entertainment.\n\nExperience the ease of on-site services with controlled access, maintenance support, and 24-hour access to laundry facilities. Engage with your neighbors through our planned social activities, or unwind in the clubhouse and lounge areas. Plus, our guest apartment ensures that your visitors feel right at home.\n\nInside your apartment, enjoy modern comforts, including air conditioning, stainless steel appliances, and spacious walk-in closets. Designed for your convenience, each unit comes with essential features like washer/dryer hookups, high-speed internet access, and ample kitchen space.\n\nLife at Falls at Spring Creek offers the perfect blend of community and comfort. Don't miss out on your future home—browse our availability or schedule a tour today to discover all that our community has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and umbrellas",
    "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
    "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "296",
  "property_year_built": "1992",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.24324324324324",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Each apartment may have up to 3 pets, with a limit of 2 dogs per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://fallsatspringcreek.loftliving.com/login",
  "property_apply_now_url": "https://8754104.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-cadf-70a5-ae2d-de0720f75b49.webp",
  "property_primary_logo_media": {
    "alt_text": "Falls at Spring Creek Apartment Homes logo",
    "public_id": "019e1e46-cadf-70a5-ae2d-de0720f75b49",
    "storage_key": "property/6737460151191759/019e1e46-cadf-70a5-ae2d-de0720f75b49.webp",
    "width": 852,
    "height": 321
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-cae3-70bf-b3a9-472894068318.webp",
  "property_secondary_logo_media": {
    "alt_text": "Falls at Spring Creek Apartment Homes logo",
    "public_id": "019e1e46-cae3-70bf-b3a9-472894068318",
    "storage_key": "property/6737460151191759/019e1e46-cae3-70bf-b3a9-472894068318.webp",
    "width": 852,
    "height": 321
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-cae3-70bf-b3a9-472894068318.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Falls at Spring Creek Apartment Homes logo",
    "public_id": "019e1e46-cae3-70bf-b3a9-472894068318",
    "storage_key": "property/6737460151191759/019e1e46-cae3-70bf-b3a9-472894068318.webp",
    "width": 852,
    "height": 321
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-cadf-70a5-ae2d-de0720f75b49.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Falls at Spring Creek Apartment Homes logo",
    "public_id": "019e1e46-cadf-70a5-ae2d-de0720f75b49",
    "storage_key": "property/6737460151191759/019e1e46-cadf-70a5-ae2d-de0720f75b49.webp",
    "width": 852,
    "height": 321
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#113e6e",
  "property_secondary_color": "#c0d2d3",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "800 - 1360",
  "property_sqft_min": "800",
  "property_sqft_max": "1360",
  "property_price_range": "1510",
  "property_price_min": "950",
  "property_price_max": "1510",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/FallsSpringCreek",
  "property_instagram_url": "https://www.instagram.com/falls_at_spring_creek",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJUXOHfYIH9IgRCKecfewEtTQ",
  "property_youtube_url": "https://www.youtube.com/watch?v=g5YCDB9Hm_o&t=196",
  "property_yelp_url": "https://www.yelp.com/biz/the-falls-at-spring-creek-macon",
  "property_tiktok_url": "https://www.tiktok.com/discover/falls-at-spring-creek-macon-apartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Falls at Spring Creek",
  "property_home_romance_title": "Embrace Your Dream Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p>Discover the charm of southern living at Falls at Spring Creek. Our <a href=\"/gallery/\">picturesque apartment community</a> is situated in Macon, Georgia. Located adjacent to The Shoppes at River Crossing, a great selection of dining, retail, and entertainment establishments are right outside your door. With convenient access to I-75, everything you need is just a short drive away.</p>",
  "property_home_floorplans_blurb": "<p>Located in Macon, Georgia we offer stunning <a href=\"/floor-plans/\">1-, 2- and 3-bedroom apartment homes</a> with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Falls at Spring Creek is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "Welcome to Falls at Spring Creek, where your ideal home awaits in beautiful Macon, GA. Choose from spacious one, two, or three-bedroom floor plans featuring high ceilings, modern stainless steel appliances, and cozy fireplaces. Enjoy exclusive amenities like our sparkling pool, fitness center, and vibrant social events. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Falls at Spring Creek in Macon, GA, our diverse floor plans—one, two, and three-bedroom apartments—offer the perfect blend of comfort and style. Immerse yourself in the vibrant neighborhood filled with local favorites and attractions. Discover the lifestyle that awaits just beyond your door. Explore our community today!",
  "property_home_reviews_blurb": "At Falls at Spring Creek in Macon, GA, our residents rave about feeling “comfortable, safe, and at home.\" With responsive staff and top-notch amenities like pools and tennis courts, it’s perfect for students, career-oriented young adults, and families alike. Join our thriving community and experience it for yourself!",
  "property_neighborhood_blurb": "<p>Located in Macon, Georgia we offer stunning <a href=\"/floor-plans/\">1-, 2- and 3-bedroom apartment homes</a> with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Falls at Spring Creek is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Indulge in the stellar amenities our community offers. Residents have access to two resort-style swimming pools with lounge areas, playgrounds, and tennis court. Exercise your mind and body at our premium fitness centers or relax at our gorgeous clubhouse. We welcome your pets so bring the whole family. Your search for the <a href=\"/floor-plans/\">perfect apartment</a> in Macon, GA has come to an end. <a href=\"/contact/\">Schedule your tour today</a> and come home to the life you’ve been dreaming of at Falls at Spring Creek!</p>",
  "property_applynow_blurb": "Welcome to Falls at Spring Creek, where your ideal living space awaits in Macon, GA. With one, two, and three-bedroom floor plans, enjoy top-notch amenities like a rejuvenating pool, fitness center, and serene sundeck. Apply now and embrace a vibrant lifestyle—lease your new home online today!",
  "property_contactus_blurb": "Welcome to Falls at Spring Creek in Macon, GA, where comfort meets style. Choose from our versatile floor plans to find your ideal one, two, or three-bedroom home. Each space is thoughtfully designed for modern living. Have questions? Contact our leasing team today and let's find your perfect match!",
  "property_faqs_blurb": "At Falls at Spring Creek in Macon, GA, find the perfect fit for your lifestyle with our diverse floor plans—choose from one, two, or three-bedroom options. Have questions? Visit our FAQs page to uncover everything you need to know about our welcoming community and ideal living experience.",
  "property_floorplans_blurb": "<p>A superb level of quality and refined style distinguishes the residences at Falls at Spring Creek. Choose from an array of one, two, and three-bedroom floor plans that are an unmatched combination of comfort and elegance. Our apartments for rent are well appointed with <a href=\"/amenities/\">modern features</a>, including stainless steel appliances, ceiling fans, wood-style flooring, spacious closets, and washer and dryer connections. Living space is increased with a balcony or patio where you can enjoy the relaxing atmosphere of the community.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Falls at Spring Creek in Macon, GA, find your perfect sanctuary with a range of one, two, and three-bedroom floor plans. Unwind by the pool, challenge friends on the tennis courts, or enjoy cozy evenings by your fireplace. Our interactive community map helps you explore your new home effortlessly!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Falls at Spring Creek in Macon, GA, your perfect home awaits! With spacious one, two, and three-bedroom floor plans designed for comfort, it’s time to elevate your living experience. Great friends make great neighbors—refer a friend today and start building your vibrant community together!",
  "property_residentaccess_blurb": "Welcome to Falls at Spring Creek in Macon, GA, where comfort meets convenience. From cozy one-bedroom to spacious three-bedroom floor plans, we cater to every lifestyle. Access your resident portal now to effortlessly manage your rent payments, schedule maintenance, and stay connected with your community!",
  "property_reviews_blurb": "At Falls at Spring Creek in Macon, GA, comfort meets community. Residents rave about the attentive staff, stating, “The management knows the other renters by name,” creating a welcoming atmosphere. With spacious apartments and top-notch amenities, it’s clear why families and students alike call this place home.  Explore our community and see what everyone is talking about!",
  "property_created_at": "1752257091344",
  "property_scheduletour_blurb": "At Falls at Spring Creek in Macon, GA, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Each floor plan caters to your distinct lifestyle. Curious about life here? Hear directly from our residents and visualize your new home! Schedule a tour today!",
  "property_thankyou_blurb": "Thank you for your inquiry! At Falls at Spring Creek in Macon, GA, our thoughtfully designed one, two, and three-bedroom floor plans offer a perfect blend of comfort and style. A dedicated team member will reach out soon to assist you in finding your ideal home. Stay tuned!",
  "property_virtualtours_blurb": "<p>At Falls at Spring Creek, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Falls at Spring Creek",
  "property_seo_title_home": "Falls at Spring Creek | Apartments in Macon, GA",
  "property_seo_description_home": "Experience vibrant living at Falls at Spring Creek in Macon, GA! Choose from 1-3 bedroom floor plans with luxurious amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Find your ideal sanctuary at Falls at Spring Creek in Macon, GA. Choose from spacious one, two, or three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_description_floorplans": "Find your ideal home at Falls at Spring Creek in Macon, GA! Choose from stylish one, two, or three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Macon, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort and convenience at Falls at Spring Creek in Macon, GA. From serene poolside gatherings to a lively clubhouse, your ideal lifestyle awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Macon, GA",
  "property_seo_description_gallery": "\"Picture your life at Falls at Spring Creek in Macon, GA! Enjoy spacious floor plans, resort-style amenities, and a vibrant community. Your dream home awaits!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Falls at Spring Creek Apartments",
  "property_seo_description_virtualtours": "Experience modern living at Falls at Spring Creek in Macon, GA. Take a virtual tour of our stylish one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Falls at Spring Creek Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Falls at Spring Creek in Macon, GA! Enjoy resort-style amenities, beautiful floor plans, and our interactive map to get started!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Macon, GA",
  "property_seo_description_neighborhood": "Uncover the charm of Macon, GA at Falls at Spring Creek! Find your perfect one, two, or three-bedroom apartment and discover nearby local favorites today!",
  "property_seo_title_contact": "Contact Us | Falls at Spring Creek",
  "property_seo_description_contact": "Experience comfort at Falls at Spring Creek in Macon, GA. Whether it’s a cozy 1-bedroom or a spacious 3-bedroom, your ideal home awaits. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Macon, GA",
  "property_seo_description_faqs": "Find answers to your questions about Falls at Spring Creek in Macon, GA! Learn about our amenities, floor plans, and community life. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Macon, GA",
  "property_seo_description_reviews": "\"Join the vibrant community at Falls at Spring Creek in Macon, GA. Read resident reviews and learn why our amenities make it the perfect place to call home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Macon, GA",
  "property_seo_description_applynow": "Experience elevated living at Falls at Spring Creek in Macon, GA! Choose from stylish one to three-bedroom apartments, complete with top-notch amenities. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Falls at Spring Creek",
  "property_seo_description_residentaccess": "Unlock convenience at Falls at Spring Creek! Access your resident portal for easy rent payments, maintenance requests, and community news—all in one place.",
  "property_seo_title_referafriend": "Refer A Friend | Falls at Spring Creek",
  "property_seo_description_referafriend": "\"Refer a friend to Falls at Spring Creek in Macon, GA! Share the joy of great living with great friends and enjoy exclusive rewards together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Falls at Spring Creek",
  "property_seo_description_scheduletour": "Experience the serene charm of Falls at Spring Creek in Macon, GA. Schedule your tour today and envision your new life in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Falls at Spring Creek",
  "property_seo_description_privacy": "Your privacy matters at Falls at Spring Creek. Dive into our commitment to your data security and transparent policies. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Falls at Spring Creek",
  "property_seo_description_accessibility": "\"At Falls at Spring Creek in Macon, GA, we're committed to digital inclusion. Experience effortless accessibility tailored for everyone in our vibrant community.\"",
  "property_seo_title_sitemap": "Sitemap | Falls at Spring Creek",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Falls at Spring Creek in Macon, GA! Check out our sitemap for a seamless journey through our community offerings.",
  "property_seo_title_thankyou": "Thank You | Falls at Spring Creek",
  "property_seo_description_thankyou": "Thank you for reaching out to Falls at Spring Creek! Immerse yourself in the charm of Macon, GA, and let our team connect you to your ideal home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Macon, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293615406",
  "amenities": [
    {
      "id": "ec_3fc1ab3f760a82d88c51b685",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "24 Hour Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9170d9f3d78b89ecfc3bc30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65df72f5fb93dcd4359b7115",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3be4cd3d1263667da2b03820",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Guest Apartment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cad58bfaa528adf6efb9bfb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8d80df75f873c3470010d9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_222b0ae3d9992d8102f4b624",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0811613192ebd29ab5cd01d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb0110987b09fa7d027a6765",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2920b125db06960844fce5f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Multi Use Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0b6e8493619c20ba06ce4c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bd5bbbb7eeeb0db353d369d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8238d810dce6ad44dd4a0ac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ba1f632f6b3b84b2f6a400b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ade4a1df5838028f1430cf8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a84d042455841fd1bd2b8a54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad775af39d9c7239ee523c12",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e7b72b0fe42640232b190e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2053eeb4bbfdfcdfafe30d3a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bcd76425c369a1feeae974b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b0050c835b6a12ac2411d0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Utility/Laundry Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0373b17b5d7f77d80c98e54e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Screened In Lanais Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fec8d87bf11473c9922214b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Screened Lanais Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0746cb9649506c46410d5574",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8277278148d0dfdc9af97d90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_582574c5c4381e298c620ca9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4aa1e1ccbf0799cbb02ec5fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bcbd81515e3ae8ea6336fa41",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf81896444da93691ade682c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9dd8ff7b9eed54394f19ecbc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_152e91f60f9f41e041b9febf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cee01b15a2e916c5f8b5920",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_750b82d552395364141221b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38e3bf4633c8a8a18163f61e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f274e7763fcaf959c6e5529e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e7a0f1928204a8a2bae227e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3da421d8a1b4482343dbe04d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e84f9aaed4e31ee7e1a2a5d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c913d609eb8d99c967e6d6ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Sunroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4949ad2baa28745c30b94448",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4faae2ef99cfb3f79bfcefab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07da619dcda8c974f06ffcf4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0855b5b1bd08c05de8764689",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Mud Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b282424a0880f13062790538",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d0a70f669d96a40baebb0c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_456cdff0cf947e3fcc0d43e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4229c69f0b974e8b95b84a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c6a1b3eaa54a59994e866d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "apartments",
      "external_id": "false",
      "title": "Porch",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a74d142c-aaeb-47e6-a1ef-b3615ea097cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-ad9b-70aa-9b42-fd59a85e36af.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019e60ea-ad9b-70aa-9b42-fd59a85e36af",
        "storage_key": "property/6737460151191759/019e60ea-ad9b-70aa-9b42-fd59a85e36af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the sparkling outdoor pool. Lounge chairs and umbrellas are available for your comfort.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a62e705f-7567-4fe1-b17c-f3aad458c1ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-3361-712f-a7b2-fbba2de6ed95.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances including a refrigerator and stove, white cabinets, and a separate laundry area with a washer and dryer.",
        "public_id": "019e60eb-3361-712f-a7b2-fbba2de6ed95",
        "storage_key": "property/6737460151191759/019e60eb-3361-712f-a7b2-fbba2de6ed95.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "A modern apartment kitchen featuring granite countertops, stainless steel appliances, ample cabinet space, and a convenient in-unit laundry area with a washer and dryer.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances including a refrigerator and stove, white cabinets, and a separate laundry area with a washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_77f6b607-9aab-4b01-a76f-7aeaf9795af2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-2c7a-76fe-b992-1fe455887c2d.webp",
      "image_media": {
        "alt_text": "Modern living room with a couch, coffee table, and TV, opening to a kitchen.",
        "public_id": "019e60eb-2c7a-76fe-b992-1fe455887c2d",
        "storage_key": "property/6737460151191759/019e60eb-2c7a-76fe-b992-1fe455887c2d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious and bright living area featuring a comfortable sofa, a stylish coffee table, and an entertainment center with a large TV. The open-concept design seamlessly connects to a well-equipped kitchen, perfect for modern living.",
      "link": "",
      "alt_text": "Modern living room with a couch, coffee table, and TV, opening to a kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dfe2c8bb-0bf9-49e2-b5e5-505e889401ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-83cf-77c1-917f-cf41db23c51b.webp",
      "image_media": {
        "alt_text": "Interior view of a well-equipped fitness center with weight machines, treadmills, and free weights.",
        "public_id": "019e60eb-83cf-77c1-917f-cf41db23c51b",
        "storage_key": "property/6737460151191759/019e60eb-83cf-77c1-917f-cf41db23c51b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide array of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Interior view of a well-equipped fitness center with weight machines, treadmills, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_687f4927-10ac-4b54-aaa6-4f24ea32acc6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-9995-701e-b818-400e7da406ca.webp",
      "image_media": {
        "alt_text": "Community lounge area with table, chairs, and seating.",
        "public_id": "019e60eb-9995-701e-b818-400e7da406ca",
        "storage_key": "property/6737460151191759/019e60eb-9995-701e-b818-400e7da406ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the community lounge area, featuring comfortable seating, a dining table, and recreational games.",
      "link": "",
      "alt_text": "Community lounge area with table, chairs, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c30b53b-9da3-47dd-aa40-a3a40f66074f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-2fa0-715d-9030-46f8417c9660.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and owl-themed wall art.",
        "public_id": "019e60eb-2fa0-715d-9030-46f8417c9660",
        "storage_key": "property/6737460151191759/019e60eb-2fa0-715d-9030-46f8417c9660.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience comfort in our beautifully appointed bedroom, featuring a plush king-size bed, elegant nightstands, and charming owl-themed decor.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and owl-themed wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_08910bfe-1c29-45b2-8eb8-5bb7031229a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-81c7-774f-a7c3-aa24dae979c0.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, a ceiling fan, and a closet.",
        "public_id": "019e60eb-81c7-774f-a7c3-aa24dae979c0",
        "storage_key": "property/6737460151191759/019e60eb-81c7-774f-a7c3-aa24dae979c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan for comfort, and ample closet space.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, a ceiling fan, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad511c84-989d-4fe1-80ae-3a22ce082d5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-8c97-7087-a34b-221f2fcc78d9.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with chairs and a bench in a community lounge.",
        "public_id": "019e60eb-8c97-7087-a34b-221f2fcc78d9",
        "storage_key": "property/6737460151191759/019e60eb-8c97-7087-a34b-221f2fcc78d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the inviting community lounge, featuring comfortable seating and elegant decor.",
      "link": "",
      "alt_text": "Comfortable seating area with chairs and a bench in a community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83c79ab4-b14a-4de1-a204-0dcfcf9e0f3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-9fdd-7749-adbc-a467efb02e91.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with wicker furniture and plants under a white pergola.",
        "public_id": "019e60eb-9fdd-7749-adbc-a467efb02e91",
        "storage_key": "property/6737460151191759/019e60eb-9fdd-7749-adbc-a467efb02e91.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind on the spacious patio, complete with comfortable seating and lush greenery, perfect for enjoying the outdoors.",
      "link": "",
      "alt_text": "Outdoor patio area with wicker furniture and plants under a white pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_834ae4b4-cec6-4c01-bcd7-90aab6b492c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-8c15-7406-8435-47532beddd97.webp",
      "image_media": {
        "alt_text": "Fitness center with various weight machines and free weights.",
        "public_id": "019e60eb-8c15-7406-8435-47532beddd97",
        "storage_key": "property/6737460151191759/019e60eb-8c15-7406-8435-47532beddd97.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a wide range of weight machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with various weight machines and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c736a3f2-e9e9-428c-b3ae-c62b1f1f8275",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-78b2-77c8-b455-83ca6430537c.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and view into living area.",
        "public_id": "019e60eb-78b2-77c8-b455-83ca6430537c",
        "storage_key": "property/6737460151191759/019e60eb-78b2-77c8-b455-83ca6430537c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, a deep sink with a pull-down faucet, stainless steel dishwasher, and refrigerator. Open to the living space.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and view into living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3675904f-435c-4686-9658-c5f7f975e5ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-71d0-77bb-be6a-fbe4e801d5d9.webp",
      "image_media": {
        "alt_text": "Spacious living room with wood-look flooring, neutral walls, and large windows.",
        "public_id": "019e60eb-71d0-77bb-be6a-fbe4e801d5d9",
        "storage_key": "property/6737460151191759/019e60eb-71d0-77bb-be6a-fbe4e801d5d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this inviting living space featuring beautiful wood-look flooring, neutral painted walls, and abundant natural light from large windows.",
      "link": "",
      "alt_text": "Spacious living room with wood-look flooring, neutral walls, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_655b8166-e718-4dee-9458-9678fd068b90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-6b77-75f1-bcbb-d1e33650f40f.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, sink, toilet, and bathtub with shower.",
        "public_id": "019e60eb-6b77-75f1-bcbb-d1e33650f40f",
        "storage_key": "property/6737460151191759/019e60eb-6b77-75f1-bcbb-d1e33650f40f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a vanity with a granite countertop and sink, a toilet, and a white bathtub with a shower.",
      "link": "",
      "alt_text": "Bathroom vanity with granite countertop, sink, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_165391a9-516d-4e07-aee4-1fdddf5a7fe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-719e-7659-a2c7-c1eee3d698c1.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot surrounded by trees.",
        "public_id": "019e60eb-719e-7659-a2c7-c1eee3d698c1",
        "storage_key": "property/6737460151191759/019e60eb-719e-7659-a2c7-c1eee3d698c1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "An aerial view showcases apartment buildings nestled amongst lush greenery, featuring a sparkling swimming pool and convenient parking facilities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_452c785c-518e-46e9-a325-f848e980221e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-5e79-72ca-aafd-86059b6d5343.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a water feature, surrounded by trees and apartment buildings.",
        "public_id": "019e60eb-5e79-72ca-aafd-86059b6d5343",
        "storage_key": "property/6737460151191759/019e60eb-5e79-72ca-aafd-86059b6d5343.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and a beautiful water feature. An oasis awaits you.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a water feature, surrounded by trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_09f90d5e-57b4-46db-9e35-e937e7781b2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-8560-7736-bb61-58e4ec130578.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
        "public_id": "019e60eb-8560-7736-bb61-58e4ec130578",
        "storage_key": "property/6737460151191759/019e60eb-8560-7736-bb61-58e4ec130578.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc8d57d3-c461-41ec-a068-3e7ff4accca1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-5cd4-70d2-a0d2-758abf8681a2.webp",
      "image_media": {
        "alt_text": "Fitness center with weight rack, exercise balls, rowing machine, and elliptical.",
        "public_id": "019e60eb-5cd4-70d2-a0d2-758abf8681a2",
        "storage_key": "property/6737460151191759/019e60eb-5cd4-70d2-a0d2-758abf8681a2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with everything you need for a great workout, including free weights, cardio machines, and more.",
      "link": "",
      "alt_text": "Fitness center with weight rack, exercise balls, rowing machine, and elliptical.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6873d41-6c85-4018-a183-a8fee3403d8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-5583-71ea-8f2b-b51797c7f317.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with a stainless steel grill, stone counter, and seating area with umbrellas.",
        "public_id": "019e60eb-5583-71ea-8f2b-b51797c7f317",
        "storage_key": "property/6737460151191759/019e60eb-5583-71ea-8f2b-b51797c7f317.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community's grilling station, complete with modern grills and comfortable seating under umbrellas.",
      "link": "",
      "alt_text": "Outdoor grilling station with a stainless steel grill, stone counter, and seating area with umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03924cc5-3b54-4e9e-909e-b24b2c925627",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-3033-7289-bea4-2ba7f2442a82.webp",
      "image_media": {
        "alt_text": "Dining area with round table, chairs, and art featuring cranes.",
        "public_id": "019e60eb-3033-7289-bea4-2ba7f2442a82",
        "storage_key": "property/6737460151191759/019e60eb-3033-7289-bea4-2ba7f2442a82.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a round table set for four, complemented by decorative art and tasteful furnishings.",
      "link": "",
      "alt_text": "Dining area with round table, chairs, and art featuring cranes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1bfc6c0-7251-4822-bcb8-b681acb05561",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-28ad-730e-b050-7c4ecd13c386.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, white sink, toilet, and bathtub with teal shower curtain.",
        "public_id": "019e60eb-28ad-730e-b050-7c4ecd13c386",
        "storage_key": "property/6737460151191759/019e60eb-28ad-730e-b050-7c4ecd13c386.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bathroom, featuring a granite vanity, spacious tub, and elegant teal shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with granite countertop, white sink, toilet, and bathtub with teal shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a8f8fb5-1032-4310-97da-9baf27d3e95b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-1ecb-77fe-8617-31e5705c6975.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables",
        "public_id": "019e60eb-1ecb-77fe-8617-31e5705c6975",
        "storage_key": "property/6737460151191759/019e60eb-1ecb-77fe-8617-31e5705c6975.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing on a sunny day. Lounge chairs and seating areas are available.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a23238a6-5d8f-4a7b-8fdf-69a4b7f41c55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-2a65-7363-a240-324e1c959c6f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a granite countertop.",
        "public_id": "019e60eb-2a65-7363-a240-324e1c959c6f",
        "storage_key": "property/6737460151191759/019e60eb-2a65-7363-a240-324e1c959c6f.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed apartment bathroom, featuring a spacious tub, clean white toilet, and a chic vanity with a granite countertop.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a4f11d44-4456-417f-8582-2c5f891d2c39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-25ad-778e-b3f6-e2e8d06b784f.webp",
      "image_media": {
        "alt_text": "Stylish living room with sofa, armchair, coffee table, and decorative artwork.",
        "public_id": "019e60eb-25ad-778e-b3f6-e2e8d06b784f",
        "storage_key": "property/6737460151191759/019e60eb-25ad-778e-b3f6-e2e8d06b784f.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed living spaces, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Stylish living room with sofa, armchair, coffee table, and decorative artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6347320d-cb9d-4f0d-8a69-48bff4b0c8ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-edb2-7291-8793-01d83ee494a8.webp",
      "image_media": {
        "alt_text": "Interior of a walk-in closet with shelves and stacked boxes.",
        "public_id": "019e60ea-edb2-7291-8793-01d83ee494a8",
        "storage_key": "property/6737460151191759/019e60ea-edb2-7291-8793-01d83ee494a8.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and a clean, neutral color palette, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Interior of a walk-in closet with shelves and stacked boxes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_963084a8-05cd-4368-9ed8-61aa3dc4d7dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-1f71-7649-97f1-4e793e00a088.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "019e60eb-1f71-7649-97f1-4e793e00a088",
        "storage_key": "property/6737460151191759/019e60eb-1f71-7649-97f1-4e793e00a088.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and ample natural light.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36834dd5-5931-44af-9423-dace3b81a1a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-199d-72f9-9781-d0429359d38d.webp",
      "image_media": {
        "alt_text": "Home office with a desk, chair, and closet.",
        "public_id": "019e60eb-199d-72f9-9781-d0429359d38d",
        "storage_key": "property/6737460151191759/019e60eb-199d-72f9-9781-d0429359d38d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Create a productive workspace in your apartment with a dedicated home office area featuring a desk, chair, and ample closet space.",
      "link": "",
      "alt_text": "Home office with a desk, chair, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f05c5170-979f-4d71-a625-be2426e44963",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-0a9a-716c-8b02-bd41b8c6936c.webp",
      "image_media": {
        "alt_text": "Outdoor community space with picnic tables, foosball, and ping pong.",
        "public_id": "019e60eb-0a9a-716c-8b02-bd41b8c6936c",
        "storage_key": "property/6737460151191759/019e60eb-0a9a-716c-8b02-bd41b8c6936c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with picnic tables, foosball, and ping pong tables in our community space.",
      "link": "",
      "alt_text": "Outdoor community space with picnic tables, foosball, and ping pong.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6115f710-b829-4850-8277-65091d54fe88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-0d11-7643-9aef-41db56103962.webp",
      "image_media": {
        "alt_text": "An inviting swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e60eb-0d11-7643-9aef-41db56103962",
        "storage_key": "property/6737460151191759/019e60eb-0d11-7643-9aef-41db56103962.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "An inviting swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2932f3c5-3835-49ca-9ab8-3ce982358ec8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-1838-76c1-b4ab-fd505ca079bf.webp",
      "image_media": {
        "alt_text": "Signage for Falls at Spring Creek Apartment Homes.",
        "public_id": "019e60eb-1838-76c1-b4ab-fd505ca079bf",
        "storage_key": "property/6737460151191759/019e60eb-1838-76c1-b4ab-fd505ca079bf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome sign for Falls at Spring Creek Apartment Homes, surrounded by lush landscaping and flowers.",
      "link": "",
      "alt_text": "Signage for Falls at Spring Creek Apartment Homes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_35789a9a-b5d6-4777-bf27-ae2047196ffa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-0373-766f-ac8e-8fa4d97431c5.webp",
      "image_media": {
        "alt_text": "Outdoor area with picnic tables, grills, and a playground.",
        "public_id": "019e60eb-0373-766f-ac8e-8fa4d97431c5",
        "storage_key": "property/6737460151191759/019e60eb-0373-766f-ac8e-8fa4d97431c5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community's picnic area, complete with grills and a playground for family fun.",
      "link": "",
      "alt_text": "Outdoor area with picnic tables, grills, and a playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3df07096-7070-4437-a2ac-70ded7da503e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-00dc-719f-85e2-63b7ee1b8c02.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and green lawns.",
        "public_id": "019e60eb-00dc-719f-85e2-63b7ee1b8c02",
        "storage_key": "property/6737460151191759/019e60eb-00dc-719f-85e2-63b7ee1b8c02.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with lush green lawns and mature trees offer a serene living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with blue siding and green lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_85250b77-67f4-497f-8d6a-8471377f2450",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-0c30-716a-8ce6-04720aa28131.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with tables and umbrellas by the pool.",
        "public_id": "019e60eb-0c30-716a-8ce6-04720aa28131",
        "storage_key": "property/6737460151191759/019e60eb-0c30-716a-8ce6-04720aa28131.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation at the community's grilling station and patio area, adjacent to the pool.",
      "link": "",
      "alt_text": "Outdoor grilling station with tables and umbrellas by the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0862982-3806-44e7-b03c-93086c715271",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-147d-77a5-972c-fb13e2ea31c1.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelves and boxes.",
        "public_id": "019e60eb-147d-77a5-972c-fb13e2ea31c1",
        "storage_key": "property/6737460151191759/019e60eb-147d-77a5-972c-fb13e2ea31c1.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and storage space.",
      "link": "",
      "alt_text": "Walk-in closet with shelves and boxes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb1bd587-2a69-4a19-abde-8ced7b322a3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-01ce-713e-a3d9-d11a9d82cdcf.webp",
      "image_media": {
        "alt_text": "Row of garage doors for resident storage.",
        "public_id": "019e60eb-01ce-713e-a3d9-d11a9d82cdcf",
        "storage_key": "property/6737460151191759/019e60eb-01ce-713e-a3d9-d11a9d82cdcf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure your belongings with our convenient on-site storage garages, offering ample space for your car or extra possessions.",
      "link": "",
      "alt_text": "Row of garage doors for resident storage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a3b1f6b-35a9-47ae-b2e5-fab47ca669e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-f6c2-75a5-9812-84d0b274a1e5.webp",
      "image_media": {
        "alt_text": "Playground with slides and apartment buildings in the background.",
        "public_id": "019e60ea-f6c2-75a5-9812-84d0b274a1e5",
        "storage_key": "property/6737460151191759/019e60ea-f6c2-75a5-9812-84d0b274a1e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and a safe play area for children.",
      "link": "",
      "alt_text": "Playground with slides and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6bd49473-9dc6-4a59-9227-ea1cec2ce179",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-edd1-74c6-839c-26c650d713fd.webp",
      "image_media": {
        "alt_text": "Pathway through green lawn leading to apartment buildings",
        "public_id": "019e60ea-edd1-74c6-839c-26c650d713fd",
        "storage_key": "property/6737460151191759/019e60ea-edd1-74c6-839c-26c650d713fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene ambiance of our community with beautifully landscaped grounds and walking paths leading to your new home.",
      "link": "",
      "alt_text": "Pathway through green lawn leading to apartment buildings",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a58a094-52ec-405c-baad-d191f650984c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-ed37-7189-9909-09361b6887b1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, and apartment buildings in the background.",
        "public_id": "019e60ea-ed37-7189-9909-09361b6887b1",
        "storage_key": "property/6737460151191759/019e60ea-ed37-7189-9909-09361b6887b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and scenic views of the property.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a487aaa-6250-4812-a0e8-8c346e620e6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-e98c-72a9-9820-88d676a299e7.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with blue siding and white balconies.",
        "public_id": "019e60ea-e98c-72a9-9820-88d676a299e7",
        "storage_key": "property/6737460151191759/019e60ea-e98c-72a9-9820-88d676a299e7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with blue siding, white railings, and lush green landscaping. Enjoy the spacious balconies and well-kept grounds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with blue siding and white balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_37b71294-7845-401f-a519-2f41877011ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-d287-717a-afad-b3fe8ad04680.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with Adirondack chairs, benches, and a fire pit.",
        "public_id": "019e60ea-d287-717a-afad-b3fe8ad04680",
        "storage_key": "property/6737460151191759/019e60ea-d287-717a-afad-b3fe8ad04680.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed outdoor seating area, featuring comfortable Adirondack chairs, communal benches, and a modern fire pit, perfect for gathering with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor seating area with Adirondack chairs, benches, and a fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a54a63b-30b7-498a-9f53-5c5ba3ba8196",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-d322-769b-934b-f1f6c888c8f0.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping.",
        "public_id": "019e60ea-d322-769b-934b-f1f6c888c8f0",
        "storage_key": "property/6737460151191759/019e60ea-d322-769b-934b-f1f6c888c8f0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings with inviting balconies and lush green lawns, offering a peaceful and well-maintained living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2fa8f298-91b0-4343-8c61-2ec101a7a61e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-cb59-749d-bbb1-74a2ed786810.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature.",
        "public_id": "019e60ea-cb59-749d-bbb1-74a2ed786810",
        "storage_key": "property/6737460151191759/019e60ea-cb59-749d-bbb1-74a2ed786810.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a relaxing waterfall feature. Perfect for sunny days!",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be8ff2db-4631-4561-bfb9-52cbb1d2a420",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-c5d1-76f2-be84-f29dcdfe108f.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building entrance with colorful flower beds.",
        "public_id": "019e60ea-c5d1-76f2-be84-f29dcdfe108f",
        "storage_key": "property/6737460151191759/019e60ea-c5d1-76f2-be84-f29dcdfe108f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a welcoming entrance surrounded by vibrant flower beds and lush landscaping.",
      "link": "",
      "alt_text": "Exterior view of the apartment building entrance with colorful flower beds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27b6a237-bc06-433b-a937-bc116386f9be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-c198-760c-ad4d-ca99a7c1d2f6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and green lawn.",
        "public_id": "019e60ea-c198-760c-ad4d-ca99a7c1d2f6",
        "storage_key": "property/6737460151191759/019e60ea-c198-760c-ad4d-ca99a7c1d2f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment building showcasing balconies and lush green lawn.",
      "link": "",
      "alt_text": "Exterior view of apartment building with balconies and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0555a00d-006a-4486-b77b-a6ef17484c1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-c3e7-722d-a405-bb238b88e520.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and seating under a pergola, with apartment buildings in the background.",
        "public_id": "019e60ea-c3e7-722d-a405-bb238b88e520",
        "storage_key": "property/6737460151191759/019e60ea-c3e7-722d-a405-bb238b88e520.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge seating and a shaded pergola for ultimate relaxation. Enjoy the resort-style amenities.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and seating under a pergola, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_64dcc061-2a50-4732-8a17-986b96162d03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-bbbe-729d-b329-18b7b1056b27.webp",
      "image_media": {
        "alt_text": "Wooden pergola with concrete flooring and green trees in the background.",
        "public_id": "019e60ea-bbbe-729d-b329-18b7b1056b27",
        "storage_key": "property/6737460151191759/019e60ea-bbbe-729d-b329-18b7b1056b27.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors under this beautiful wooden pergola. Perfect for gatherings or simply relaxing in the shade.",
      "link": "",
      "alt_text": "Wooden pergola with concrete flooring and green trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92aa881b-7ad5-46f0-a762-c99a8251b502",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-afb3-771b-b77b-02a1f272250c.webp",
      "image_media": {
        "alt_text": "Swimming pool with a waterfall feature and lounge chairs.",
        "public_id": "019e60ea-afb3-771b-b77b-02a1f272250c",
        "storage_key": "property/6737460151191759/019e60ea-afb3-771b-b77b-02a1f272250c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with a soothing waterfall and ample lounge seating.",
      "link": "",
      "alt_text": "Swimming pool with a waterfall feature and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_428fe836-0c7b-41e8-88c7-cf83548aa846",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-ace9-7764-a160-31b3064843d3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a waterfall feature.",
        "public_id": "019e60ea-ace9-7764-a160-31b3064843d3",
        "storage_key": "property/6737460151191759/019e60ea-ace9-7764-a160-31b3064843d3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling resort-style swimming pool, complete with a soothing waterfall and ample lounge seating for your enjoyment.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a waterfall feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_743aeacd-0995-45ee-b67f-c86b2de8f37f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-a40b-757d-a048-fcedc9121cc4.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and chairs.",
        "public_id": "019e60ea-a40b-757d-a048-fcedc9121cc4",
        "storage_key": "property/6737460151191759/019e60ea-a40b-757d-a048-fcedc9121cc4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather around the fire pit with friends and enjoy the outdoors in this cozy community seating area.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_73a610a5-0ac3-4adc-9b72-0d37c5b4ce22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-a73b-7292-8ae5-fbf205fba0b7.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with blue siding and white balconies.",
        "public_id": "019e60ea-a73b-7292-8ae5-fbf205fba0b7",
        "storage_key": "property/6737460151191759/019e60ea-a73b-7292-8ae5-fbf205fba0b7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring blue siding, white railings, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment building with blue siding and white balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c0554fd-28b2-4ae2-969a-bbeebdcd2642",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-9d09-703a-b5c4-c5838dd7780d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e60ea-9d09-703a-b5c4-c5838dd7780d",
        "storage_key": "property/6737460151191759/019e60ea-9d09-703a-b5c4-c5838dd7780d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a serene waterfall feature. Perfect for a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d7db3b7-e0a9-4cc5-8dd7-183bf0ac658b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-9ce8-731e-9ed7-8d40bb541fd5.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and grills.",
        "public_id": "019e60ea-9ce8-731e-9ed7-8d40bb541fd5",
        "storage_key": "property/6737460151191759/019e60ea-9ce8-731e-9ed7-8d40bb541fd5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community's outdoor grilling area, complete with picnic tables and modern grills for resident use.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc99dd2f-95f4-45f4-8d8f-bd1c69b519f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60ea-9074-74db-8c87-41c909f64360.webp",
      "image_media": {
        "alt_text": "Outdoor covered lounge area with modern wicker furniture and concrete tables.",
        "public_id": "019e60ea-9074-74db-8c87-41c909f64360",
        "storage_key": "property/6737460151191759/019e60ea-9074-74db-8c87-41c909f64360.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge, featuring comfortable seating and chic concrete tables, perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor covered lounge area with modern wicker furniture and concrete tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_17209b16-d010-4fb8-95e9-16ee8ec833d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-7be5-763e-a18c-b9ca8875f23b.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, a swimming pool, and a playground.",
        "public_id": "019e60eb-7be5-763e-a18c-b9ca8875f23b",
        "storage_key": "property/6737460151191759/019e60eb-7be5-763e-a18c-b9ca8875f23b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover this community's inviting amenities, featuring a sparkling swimming pool and a fun-filled playground, all surrounded by lush greenery.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings, a swimming pool, and a playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_980d110d-ae43-4856-81b3-2e0d7d5adf6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e60eb-5f6b-744a-9146-97352cf22f1f.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by lush green trees, with a swimming pool visible.",
        "public_id": "019e60eb-5f6b-744a-9146-97352cf22f1f",
        "storage_key": "property/6737460151191759/019e60eb-5f6b-744a-9146-97352cf22f1f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience serene living amidst abundant greenery. Our community features beautiful apartment buildings and a sparkling swimming pool, perfect for relaxation.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounded by lush green trees, with a swimming pool visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b199e0d2-5778-49dc-8332-fa7a06085ecf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5080 Riverside Dr Suite 1500, Macon, GA 31210, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-7fc7-75aa-a9c3-03760b04440d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-7fc7-75aa-a9c3-03760b04440d",
        "storage_key": "property/6737460151191759/019e1e46-7fc7-75aa-a9c3-03760b04440d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/georgia/macon?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7708744444521463649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.9245606",
      "poi_longitude": "-83.71236239999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 478-477-3777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRYb_3xzr2-mo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ca28d48a-0ba1-4513-b6ee-4a4f58868b3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "La Parrilla Mexican Restaurant - Macon, GA",
      "poi_type": "Restaurants",
      "poi_address": "5080 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Colorful, family-friendly chain serving a variety of Mexican dishes & margaritas.",
      "poi_long_description": "Colorful, family-friendly chain serving a variety of Mexican dishes & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-3c45-7495-b36a-9626296150d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-3c45-7495-b36a-9626296150d7",
        "storage_key": "property/6737460151191759/019e1e48-3c45-7495-b36a-9626296150d7.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.laparrilla.com/locations/macon-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=15270457504772701227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-parrilla-mexican-restaurant---macon-ga",
      "poi_latitude": "32.9262633",
      "poi_longitude": "-83.71360949999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 478-475-5492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRK7ysuTGQ69M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_5b41865e-5eb5-4ceb-a453-846000f5698e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4950 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-403d-7578-8b6f-06960d88e73e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-403d-7578-8b6f-06960d88e73e",
        "storage_key": "property/6737460151191759/019e1e48-403d-7578-8b6f-06960d88e73e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ga/macon/macon/6411?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:macon-ga-6411_pl:locurl_rd:1842",
      "poi_directions_map_url": "https://maps.google.com/?cid=1995066652428164787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "32.9258061",
      "poi_longitude": "-83.7129846",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-477-0008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1aG2uf784gRs1410Yzmrxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b215d2ba-23e0-445a-be83-86c79a34a3d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "3913 River Pl Dr, Macon, GA 31210, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4087-7129-bd0c-3c31b80bd3e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4087-7129-bd0c-3c31b80bd3e0",
        "storage_key": "property/6737460151191759/019e1e48-4087-7129-bd0c-3c31b80bd3e0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.carrabbas.com/georgia/macon/3913-river-place-drive?y_source=1_MTU1MDI5MzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6767543011044040109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrabbas-italian-grill",
      "poi_latitude": "32.9056745",
      "poi_longitude": "-83.6859075",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-474-5115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9RhjVrD484gRrR11N4Mk610",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_5ab248bf-a5ad-416e-99fa-7db0325fac5d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "3950 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-7aa3-75fd-827a-42bfca73947e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-7aa3-75fd-827a-42bfca73947e",
        "storage_key": "property/6737460151191759/019e1e46-7aa3-75fd-827a-42bfca73947e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ga/macon/46/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=37612520828105272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "32.9038498",
      "poi_longitude": "-83.68972839999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-474-7029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wsbO7r484gROPIQb2OghQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_609e81d9-d2ef-4127-be25-4c7358309e92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Chevo's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4921 Riverside Dr Suite 2, Macon, GA 31210, USA",
      "poi_short_description": "Family-run eatery specializing in Mexican classics like tacos, burritos and fajitas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-3ca2-7453-85ad-e8d4a57113ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-3ca2-7453-85ad-e8d4a57113ae",
        "storage_key": "property/6737460151191759/019e1e48-3ca2-7453-85ad-e8d4a57113ae.webp",
        "width": 1084,
        "height": 724
      },
      "poi_business_url": "https://www.chevosmexican.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9021911900138922139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevos-mexican-restaurant",
      "poi_latitude": "32.926609",
      "poi_longitude": "-83.7114727",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-254-3468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_xn1yoH9IgRm2CmshJFNH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d13d699d-dce9-4d95-82cd-2a831a24bbf5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Fresh Air Barbecue - Macon",
      "poi_type": "Restaurants",
      "poi_address": "3076 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Old-fashioned establishment turning out Southern BBQ staples like slow-cooked pork & Brunswick stew.",
      "poi_long_description": "Old-fashioned establishment turning out Southern BBQ staples like slow-cooked pork & Brunswick stew.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-3f8a-74a2-9173-721dbbc91488.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-3f8a-74a2-9173-721dbbc91488",
        "storage_key": "property/6737460151191759/019e1e48-3f8a-74a2-9173-721dbbc91488.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "http://freshairbarbecue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3611729860069034472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fresh-air-barbecue---macon",
      "poi_latitude": "32.8887444",
      "poi_longitude": "-83.67750559999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-477-7229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ywCz8z484gR6AkWBixxHzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_75c90ab5-e7b3-4def-be42-7ae16cf0a4fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Jim Shaw's Seafood Grill",
      "poi_type": "Restaurants",
      "poi_address": "3040 Vineville Ave, Macon, GA 31204, USA",
      "poi_short_description": "Local shrimp & seafood dishes plus a lengthy beer menu in a casual, family-friendly venue.",
      "poi_long_description": "Local shrimp & seafood dishes plus a lengthy beer menu in a casual, family-friendly venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-3c9f-771d-99e6-46392bfda48a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-3c9f-771d-99e6-46392bfda48a",
        "storage_key": "property/6737460151191759/019e1e48-3c9f-771d-99e6-46392bfda48a.webp",
        "width": 800,
        "height": 479
      },
      "poi_business_url": "https://www.jimshawseafoodga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16618564874235928506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jim-shaws-seafood-grill",
      "poi_latitude": "32.8495128",
      "poi_longitude": "-83.67362899999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-746-3697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yWBt7X-84gRut-dRbQAoeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_5c36cd8d-7084-465e-a6f2-e9c07ccddf6a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "The Rookery",
      "poi_type": "Restaurants",
      "poi_address": "543 Cherry St, Macon, GA 31201, USA",
      "poi_short_description": "Lively hangout known for its burgers, broad selection of craft brews, live music & outdoor patio.",
      "poi_long_description": "Lively hangout known for its burgers, broad selection of craft brews, live music & outdoor patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-41ea-721f-a5e8-d51f37f0069f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-41ea-721f-a5e8-d51f37f0069f",
        "storage_key": "property/6737460151191759/019e1e48-41ea-721f-a5e8-d51f37f0069f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rookerymacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7414134812258493566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rookery",
      "poi_latitude": "32.8362711",
      "poi_longitude": "-83.6281281",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-746-8658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjedvFHv-84gRfmSGeVRM5GY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d489b23c-803f-47cd-b3fe-d52ee1587647",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Kudzu Seafood Company",
      "poi_type": "Restaurants",
      "poi_address": "512 Poplar St, Macon, GA 31201, USA",
      "poi_short_description": "Small, high-ceilinged spot with a casual vibe & menu of Southern seafood, burgers & po’ boys.",
      "poi_long_description": "Small, high-ceilinged spot with a casual vibe & menu of Southern seafood, burgers & po’ boys.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-542e-75c8-ae3e-64b3ec1ce990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-542e-75c8-ae3e-64b3ec1ce990",
        "storage_key": "property/6737460151191759/019e1e48-542e-75c8-ae3e-64b3ec1ce990.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kudzuseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14095052930883237996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kudzu-seafood-company",
      "poi_latitude": "32.8342349",
      "poi_longitude": "-83.6292009",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-292-2085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeC5onv-84gRbLifO_avm8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_dfef8d0c-3b1a-42c0-b7ca-4f037a6e4761",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Ingleside Village Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2395 Ingleside Ave, Macon, GA 31204, USA",
      "poi_short_description": "Quirky sit-down pizzeria with New York-style pies, subs & an expansive roster of imported beers.",
      "poi_long_description": "Quirky sit-down pizzeria with New York-style pies, subs & an expansive roster of imported beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-3f6b-70a8-9384-31b1cf755514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-3f6b-70a8-9384-31b1cf755514",
        "storage_key": "property/6737460151191759/019e1e48-3f6b-70a8-9384-31b1cf755514.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://inglesidevillagepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6866813703610957645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingleside-village-pizza",
      "poi_latitude": "32.8539536",
      "poi_longitude": "-83.6572434",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 478-750-8488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WyiysH-84gRTf-Ddq7SS18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_84cfc8c7-b5c5-42c1-adb3-9c996d1701b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Village Coffee",
      "poi_type": "Restaurants",
      "poi_address": "2391 Ingleside Ave, Macon, GA 31204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4290-776c-894d-48bbde2f54c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4290-776c-894d-48bbde2f54c8",
        "storage_key": "property/6737460151191759/019e1e48-4290-776c-894d-48bbde2f54c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://vcmacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8059042622590897857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-coffee",
      "poi_latitude": "32.85391990000001",
      "poi_longitude": "-83.65708029999999",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-9305-7328-a662-2cad0628476e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-9305-7328-a662-2cad0628476e",
        "storage_key": "property/6737460151191759/019e1e48-9305-7328-a662-2cad0628476e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7_dwegD_84gRwU5DDZF4128",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_3e2f4d5b-303c-403e-b318-1bbecc3847bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Cathedral Coffee",
      "poi_type": "Restaurants",
      "poi_address": "5915 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "Calm coffee shop with high ceilings, plus baked goods and smoothies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-46de-702c-9258-e043dc6553db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-46de-702c-9258-e043dc6553db",
        "storage_key": "property/6737460151191759/019e1e48-46de-702c-9258-e043dc6553db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cathedralcoffee.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12164330980107392938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cathedral-coffee",
      "poi_latitude": "32.8816731",
      "poi_longitude": "-83.75725489999999",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-476-1962",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-9305-7328-a662-2cad0628476e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-9305-7328-a662-2cad0628476e",
        "storage_key": "property/6737460151191759/019e1e48-9305-7328-a662-2cad0628476e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJjYOJKVH584gRqpeUt5Ni0Kg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_4e45ec87-15b8-4d3f-98c9-4dbca7f41f0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Nu-Way Weiners / Northside Drive",
      "poi_type": "Restaurants",
      "poi_address": "3780 Northside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Veteran (since 1916) fast-food spot known for its chili dogs, plus breakfast & burgers.",
      "poi_long_description": "Veteran (since 1916) fast-food spot known for its chili dogs, plus breakfast & burgers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-42fe-779f-b713-f238d4dcca9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-42fe-779f-b713-f238d4dcca9f",
        "storage_key": "property/6737460151191759/019e1e48-42fe-779f-b713-f238d4dcca9f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://nu-wayweiners.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3231996100766485328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nu-way-weiners--northside-drive",
      "poi_latitude": "32.8969715",
      "poi_longitude": "-83.6927345",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 478-477-0533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3cpSI5X484gRUEuibVRb2iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6fafcfbc-31f3-445f-9e49-ef354b332bc2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Cox Cafe",
      "poi_type": "Restaurants",
      "poi_address": "694 Lower Poplar St, Macon, GA 31201, USA",
      "poi_short_description": "Breakfast and lunch spot with Southern dishes, including grits, salmon patties and cornbread.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-46f2-755c-aefa-97e2aee91ce4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-46f2-755c-aefa-97e2aee91ce4",
        "storage_key": "property/6737460151191759/019e1e48-46f2-755c-aefa-97e2aee91ce4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17093486739566449246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cox-cafe",
      "poi_latitude": "32.8250111",
      "poi_longitude": "-83.6125349",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 478-745-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6e-76a3-9d9d-3be6ad5551af",
        "storage_key": "property/6737460151191759/019e1e46-9d6e-76a3-9d9d-3be6ad5551af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp621E-D984gRXlK13J9DOO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_aaf7fe6e-0cae-47d9-89b2-82af884c9afc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4650 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4614-743a-b2c6-9b0d0aa98194.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4614-743a-b2c6-9b0d0aa98194",
        "storage_key": "property/6737460151191759/019e1e48-4614-743a-b2c6-9b0d0aa98194.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/macon/wesleyan-station/011/00355?cid=loc_01100355_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6606103858955071840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.8732422",
      "poi_longitude": "-83.7097876",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-474-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d2a-7125-96e6-88d5e6edce4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d2a-7125-96e6-88d5e6edce4c",
        "storage_key": "property/6737460151191759/019e1e46-9d2a-7125-96e6-88d5e6edce4c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05zC1QL584gRYLFahnWYrVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1fa5ef36-957b-4aa5-8eb2-f8073cfb4f1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Shell",
      "poi_type": "Shopping & Retail",
      "poi_address": "4451 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4ac4-77fa-90b6-a99e022951c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4ac4-77fa-90b6-a99e022951c2",
        "storage_key": "property/6737460151191759/019e1e48-4ac4-77fa-90b6-a99e022951c2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/10084445-4451-forsyth-rd/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=5282984610873057686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "32.8699347",
      "poi_longitude": "-83.7003987",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 478-474-6802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-930b-72b2-a6f4-502ef6d5ab62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-930b-72b2-a6f4-502ef6d5ab62",
        "storage_key": "property/6737460151191759/019e1e48-930b-72b2-a6f4-502ef6d5ab62.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3E8Mx_584gRlqHxXIPuUEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_2716090e-8c18-4c2e-a3a7-ddbbf2e2bf6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "6205 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "Convenience store and gas station offering coffee, snacks, and an ATM, plus premium fuels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-488a-76e9-9fa3-7c616bec42b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-488a-76e9-9fa3-7c616bec42b6",
        "storage_key": "property/6737460151191759/019e1e48-488a-76e9-9fa3-7c616bec42b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/macon/6205-zebulon-rd/2706730?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4370078592249481972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "32.8803564",
      "poi_longitude": "-83.7645431",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-471-8304",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-931b-70e9-bb1a-20e8117ee313.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-931b-70e9-bb1a-20e8117ee313",
        "storage_key": "property/6737460151191759/019e1e48-931b-70e9-bb1a-20e8117ee313.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJd7HgSID384gR9MqRc1OjpTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_cde1895e-8eed-4f78-b6f9-f7b94c552130",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Publix Super Market at Rivergate Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "195 Tom Hill Sr Blvd, Macon, GA 31210, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4c3f-76b7-a070-f8cb1a237eb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4c3f-76b7-a070-f8cb1a237eb5",
        "storage_key": "property/6737460151191759/019e1e48-4c3f-76b7-a070-f8cb1a237eb5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_term=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=1100431207655798418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-rivergate-shopping-center",
      "poi_latitude": "32.8971714",
      "poi_longitude": "-83.6872248",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-757-6520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d2a-7125-96e6-88d5e6edce4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d2a-7125-96e6-88d5e6edce4c",
        "storage_key": "property/6737460151191759/019e1e46-9d2a-7125-96e6-88d5e6edce4c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6DKe7f484gRkvYTYFqERQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_162a36ea-6364-47c2-944d-966a6099cafa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "4501 Log Cabin Dr, Macon, GA 31204, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4dce-744d-ad9d-2845a3d086d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4dce-744d-ad9d-2845a3d086d8",
        "storage_key": "property/6737460151191759/019e1e48-4dce-744d-ad9d-2845a3d086d8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/macon/4501-log-cabin-drive/l888",
      "poi_directions_map_url": "https://maps.google.com/?cid=12965444020528496503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "32.821315",
      "poi_longitude": "-83.710561",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d2a-7125-96e6-88d5e6edce4c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d2a-7125-96e6-88d5e6edce4c",
        "storage_key": "property/6737460151191759/019e1e46-9d2a-7125-96e6-88d5e6edce4c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPWwIP9D784gRdz_QjqSC7rM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_a6cb078f-a819-4387-a85d-035f8669f57f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "4701 Log Cabin Dr, Macon, GA 31204, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4f10-76c7-a66f-26f0da3b395e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4f10-76c7-a66f-26f0da3b395e",
        "storage_key": "property/6737460151191759/019e1e48-4f10-76c7-a66f-26f0da3b395e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8225-macon-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=2875564855480803976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "32.8152861",
      "poi_longitude": "-83.71177349999999",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 478-788-6121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d25-743d-b8a7-2e2dccf9f161",
        "storage_key": "property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1wV7JM_784gRiOKHKwAP6Cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_ef8c1fc5-d869-4de7-84a8-479b780b1fd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "5955 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "Chain department store offering a variety of goods, including electronics, clothing, home furnishings, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4b11-7735-882c-fbe845a3b596.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4b11-7735-882c-fbe845a3b596",
        "storage_key": "property/6737460151191759/019e1e48-4b11-7735-882c-fbe845a3b596.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2890-macon-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13581640909292632283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.8830479",
      "poi_longitude": "-83.76007849999999",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-471-9150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d25-743d-b8a7-2e2dccf9f161",
        "storage_key": "property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwb_a_yr484gR2_hMyXKue7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4a3d9b74-9c1b-42c9-8355-5f6e313ff32d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6275 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-4f79-711b-8131-09584ba1720a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-4f79-711b-8131-09584ba1720a",
        "storage_key": "property/6737460151191759/019e1e48-4f79-711b-8131-09584ba1720a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ga/macon-992.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2995663916026504533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "32.884266",
      "poi_longitude": "-83.767217",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-474-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d25-743d-b8a7-2e2dccf9f161",
        "storage_key": "property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy5pXVoH384gRVSU3vXW8kik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_615b4852-941b-430c-9618-8ec36dbe4a40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "The Marketplace at Payne Mill",
      "poi_type": "Shopping & Retail",
      "poi_address": "342 Rose Ave, Macon, GA 31204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-579d-75ea-9c3d-e88686eb6f3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-579d-75ea-9c3d-e88686eb6f3d",
        "storage_key": "property/6737460151191759/019e1e48-579d-75ea-9c3d-e88686eb6f3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maconmarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5832530165689120152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-marketplace-at-payne-mill",
      "poi_latitude": "32.8520413",
      "poi_longitude": "-83.6784312",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-216-5036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d25-743d-b8a7-2e2dccf9f161",
        "storage_key": "property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAQAwXzX584gRmHWmm0hP8VA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_9ca29e50-47fa-42bd-b608-4646a2b29ef2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Tattnall Square Academy",
      "poi_type": "Education",
      "poi_address": "111 Trojan Trail, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-5302-700c-b9a4-84721177a0d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-5302-700c-b9a4-84721177a0d2",
        "storage_key": "property/6737460151191759/019e1e48-5302-700c-b9a4-84721177a0d2.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "http://www.tattnall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16917662119906102040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tattnall-square-academy",
      "poi_latitude": "32.8916356",
      "poi_longitude": "-83.7207753",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-477-6760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDb3Un1j484gRGMsVfxCcx-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b08c9341-4f25-4112-a190-370764e86950",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Academy for Classical Education ACE",
      "poi_type": "Education",
      "poi_address": "5665 New Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-5232-732f-b05e-7b8490136293.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-5232-732f-b05e-7b8490136293",
        "storage_key": "property/6737460151191759/019e1e48-5232-732f-b05e-7b8490136293.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "http://acemacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6483590218671999360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academy-for-classical-education-ace",
      "poi_latitude": "32.938716",
      "poi_longitude": "-83.72835490000001",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-238-5757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOQ1zh5kH9IgRgEkkzfNW-lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d1b35431-1a42-4e1e-a7ae-4a4f36e4f353",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Springdale Elementary School",
      "poi_type": "Education",
      "poi_address": "4965 Northside Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-574d-72ee-b957-ae324df3a2e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-574d-72ee-b957-ae324df3a2e5",
        "storage_key": "property/6737460151191759/019e1e48-574d-72ee-b957-ae324df3a2e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://springdale.bcsdk12.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11069119620186284475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springdale-elementary-school",
      "poi_latitude": "32.90498",
      "poi_longitude": "-83.71973299999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-779-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt75L_In484gRu6GC2aVpnZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_53a75cd3-6c86-49d8-9542-954316d0c786",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Childcare Network",
      "poi_type": "Education",
      "poi_address": "3940 Northside Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-5424-77ee-a8f9-4bd7f3bcdf5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-5424-77ee-a8f9-4bd7f3bcdf5b",
        "storage_key": "property/6737460151191759/019e1e48-5424-77ee-a8f9-4bd7f3bcdf5b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://schools.childcarenetwork.com/ga/macon/3940-northside-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=12542910775976583191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childcare-network",
      "poi_latitude": "32.8983201",
      "poi_longitude": "-83.6991219",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 478-474-7163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE9dQUZX484gRF-CAQ-VeEa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_b95285f1-8ed0-4e16-b32e-513bc3268904",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Howard Middle School",
      "poi_type": "Education",
      "poi_address": "6600 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-543f-74d9-b5a9-e934dbe402d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-543f-74d9-b5a9-e934dbe402d7",
        "storage_key": "property/6737460151191759/019e1e48-543f-74d9-b5a9-e934dbe402d7.webp",
        "width": 1120,
        "height": 672
      },
      "poi_business_url": "https://howardms.bcsdk12.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4895612646294401225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "howard-middle-school",
      "poi_latitude": "32.9048802",
      "poi_longitude": "-83.77272479999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-779-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bDUSe7384gRybBJhMO18EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_61601fb8-6562-4a4e-b8fd-632f06188f8f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Howard High School",
      "poi_type": "Education",
      "poi_address": "6400 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-5cca-7387-a2cf-b906f161cce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-5cca-7387-a2cf-b906f161cce6",
        "storage_key": "property/6737460151191759/019e1e48-5cca-7387-a2cf-b906f161cce6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://howardhs.bcsdk12.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5059986498121000169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "howard-high-school",
      "poi_latitude": "32.9025192",
      "poi_longitude": "-83.77365259999999",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-779-4850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJExRnzPL384gR6WTGPOmuOEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_70a77c36-04dd-44e1-a4cc-dbbf54a7fb38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "First Presbyterian Day School",
      "poi_type": "Education",
      "poi_address": "5671 Calvin Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-6229-7055-8dca-30208b71e558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-6229-7055-8dca-30208b71e558",
        "storage_key": "property/6737460151191759/019e1e48-6229-7055-8dca-30208b71e558.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fpdmacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9865391176756041790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-presbyterian-day-school",
      "poi_latitude": "32.8730433",
      "poi_longitude": "-83.74979359999999",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-477-6505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeYTO1s3584gRPhjRlAHp6Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_de7272c7-3414-4041-92ea-c54f7400b931",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Montessori of Macon",
      "poi_type": "Education",
      "poi_address": "855 Tolliver Pl, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-5de8-735d-ae62-42f5519d4cca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-5de8-735d-ae62-42f5519d4cca",
        "storage_key": "property/6737460151191759/019e1e48-5de8-735d-ae62-42f5519d4cca.webp",
        "width": 680,
        "height": 669
      },
      "poi_business_url": "http://www.montessoriofmacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15894669721406111541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-of-macon",
      "poi_latitude": "32.9064841",
      "poi_longitude": "-83.7016066",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-757-8927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0z0f_pb484gRNX-R5uU1ldw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_13633728-88d8-4bdf-a696-0678dd89023a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Union Elementary School",
      "poi_type": "Education",
      "poi_address": "4831 Mamie Carter Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9099009834921642649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-elementary-school",
      "poi_latitude": "32.8366096",
      "poi_longitude": "-83.7232343",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 478-779-2650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW5wcFIH584gRmUpKejwtRn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3b04204f-cdc8-413a-9326-02425ea3b318",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "The Shoppes at River Crossing",
      "poi_type": "Entertainment",
      "poi_address": "5080 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Strip mall featuring a variety of dining & shopping options, from electronics to shoes.",
      "poi_long_description": "Strip mall featuring a variety of dining & shopping options, from electronics to shoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-7b65-76b9-8d02-6108164a5dc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-7b65-76b9-8d02-6108164a5dc8",
        "storage_key": "property/6737460151191759/019e1e46-7b65-76b9-8d02-6108164a5dc8.webp",
        "width": 1280,
        "height": 510
      },
      "poi_business_url": "https://www.theshoppesatrivercrossing.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6541699009911410211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shoppes-at-river-crossing",
      "poi_latitude": "32.9267397",
      "poi_longitude": "-83.7152815",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 478-254-2941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d25-743d-b8a7-2e2dccf9f161",
        "storage_key": "property/6737460151191759/019e1e46-9d25-743d-b8a7-2e2dccf9f161.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRI05LEZfIyFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_90cf1512-0d21-4ea6-a919-1f0ff70e2946",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "AmStar Macon by Santikos",
      "poi_type": "Entertainment",
      "poi_address": "5996 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-5de8-735d-ae62-4671c1ea0cc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-5de8-735d-ae62-4671c1ea0cc6",
        "storage_key": "property/6737460151191759/019e1e48-5de8-735d-ae62-4671c1ea0cc6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/macon/amstar-macon/theater-info",
      "poi_directions_map_url": "https://maps.google.com/?cid=9486002900734671833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amstar-macon-by-santikos",
      "poi_latitude": "32.8780557",
      "poi_longitude": "-83.7624237",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-9307-741c-bad8-0a66389015b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-9307-741c-bad8-0a66389015b1",
        "storage_key": "property/6737460151191759/019e1e48-9307-741c-bad8-0a66389015b1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJSUPd_X_384gR2XudFGENpYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_7ab07e5f-752b-444b-9df9-5aff72fc5fe8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Macon Little Theatre",
      "poi_type": "Entertainment",
      "poi_address": "4220 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "Community theater presenting contemporary, family-friendly plays & musicals since 1934.",
      "poi_long_description": "Community theater presenting contemporary, family-friendly plays & musicals since 1934.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-6244-753c-934e-2af1138e06e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-6244-753c-934e-2af1138e06e8",
        "storage_key": "property/6737460151191759/019e1e48-6244-753c-934e-2af1138e06e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://maconlittletheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13844877208845392555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-little-theatre",
      "poi_latitude": "32.8660025",
      "poi_longitude": "-83.69478219999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-471-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRFSECP584gRq5oh2HfiIsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_6c7c8418-09a7-40a8-8215-2f00a4087936",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Tubman Museum",
      "poi_type": "Entertainment",
      "poi_address": "310 Cherry St, Macon, GA 31201, USA",
      "poi_short_description": "Established in 1981, this museum houses exhibits on African-American history, art & culture.",
      "poi_long_description": "Established in 1981, this museum houses exhibits on African-American history, art & culture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-6a74-7739-b8ef-19fc3fbeaa57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-6a74-7739-b8ef-19fc3fbeaa57",
        "storage_key": "property/6737460151191759/019e1e48-6a74-7739-b8ef-19fc3fbeaa57.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.tubmanmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2145910552429185495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tubman-museum",
      "poi_latitude": "32.8336795",
      "poi_longitude": "-83.6252367",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-743-8544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d37-70dc-bcf3-4aaf880a148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d37-70dc-bcf3-4aaf880a148e",
        "storage_key": "property/6737460151191759/019e1e46-9d37-70dc-bcf3-4aaf880a148e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4NrE3r-84gR18lNJUfOxx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_2bd90432-f40e-4ab1-80f9-2d390eb8853d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Capitol Theatre Macon",
      "poi_type": "Entertainment",
      "poi_address": "382 2nd St, Macon, GA 31201, USA",
      "poi_short_description": "Restored circa-1916 movie palace presenting varied contemporary live music acts & films.",
      "poi_long_description": "Restored circa-1916 movie palace presenting varied contemporary live music acts & films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-615e-76c8-bcfe-f821a159f01b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-615e-76c8-bcfe-f821a159f01b",
        "storage_key": "property/6737460151191759/019e1e48-615e-76c8-bcfe-f821a159f01b.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.capitoltheatremacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4960493347563274676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capitol-theatre-macon",
      "poi_latitude": "32.8367603",
      "poi_longitude": "-83.628637",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-257-6391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpxYaanv-84gRtIEy9Go210Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_6d8ab459-60f4-4dcf-a875-c47d7a19072e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "The Douglass Theatre",
      "poi_type": "Entertainment",
      "poi_address": "355 Martin Luther King Jr Blvd, Macon, GA 31201, USA",
      "poi_short_description": "Long-standing, renovated theater showcasing limited-run & premier films, plus various performances.",
      "poi_long_description": "Long-standing, renovated theater showcasing limited-run & premier films, plus various performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-62a7-73c8-8da6-d2206ae3d190.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-62a7-73c8-8da6-d2206ae3d190",
        "storage_key": "property/6737460151191759/019e1e48-62a7-73c8-8da6-d2206ae3d190.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://douglasstheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6538973392826577673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-douglass-theatre",
      "poi_latitude": "32.8354375",
      "poi_longitude": "-83.6257959",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-742-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5EIYHr-84gRCbMo46cZv1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_47aa068c-0844-4b21-abf5-ba1d5d37329f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "The Piedmont Grand Opera House",
      "poi_type": "Entertainment",
      "poi_address": "651 Mulberry St, Macon, GA 31201, USA",
      "poi_short_description": "This ornate 1884 concert hall features music performances, Broadway shows & other cultural events.",
      "poi_long_description": "This ornate 1884 concert hall features music performances, Broadway shows & other cultural events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-662c-76e8-95c1-fa7feb8b114b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-662c-76e8-95c1-fa7feb8b114b",
        "storage_key": "property/6737460151191759/019e1e48-662c-76e8-95c1-fa7feb8b114b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thegrandmacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435714553452345416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-piedmont-grand-opera-house",
      "poi_latitude": "32.8385354",
      "poi_longitude": "-83.6283998",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-301-5470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93vbsWT-84gRSLjmdxgb05A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "opera_house"
    },
    {
      "id": "custom_b37927d4-ae44-4626-a983-bb3509d60b82",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Mercer Music at Capricorn",
      "poi_type": "Entertainment",
      "poi_address": "530 Martin Luther King Jr Blvd, Macon, GA 31201, USA",
      "poi_short_description": "Multi-use venue featuring a museum as well as a recording studio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-6b24-77ea-aa36-cbc19f56ba57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-6b24-77ea-aa36-cbc19f56ba57",
        "storage_key": "property/6737460151191759/019e1e48-6b24-77ea-aa36-cbc19f56ba57.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://capricorn.mercer.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8641734628855623836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercer-music-at-capricorn",
      "poi_latitude": "32.8328854",
      "poi_longitude": "-83.62720449999999",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-301-7625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUzmW1nv-84gRnLAh7Nub7Xc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_246344c0-22dd-4652-a54c-1cb3b47f7bf2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Atrium Health Navicent Urgent Care Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "5925 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-69b2-72aa-ab7a-cd05b6ea4dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-69b2-72aa-ab7a-cd05b6ea4dc0",
        "storage_key": "property/6737460151191759/019e1e48-69b2-72aa-ab7a-cd05b6ea4dc0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://navicenthealth.org/service-center/urgent-care-navicent-health/northwest-urgent-care?utm_source=GMB&utm_medium=Organic&utm_campaign=AHN",
      "poi_directions_map_url": "https://maps.google.com/?cid=13840186400589369933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-navicent-urgent-care-northwest",
      "poi_latitude": "32.8803103",
      "poi_longitude": "-83.7591462",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-757-7865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrwZkGiv484gRTVJS8DM4EsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ffed561f-e536-4fce-a3f4-1ca35cb56f25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Piedmont Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "5791 Zebulon Rd Suite A, Suite A, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-6b80-70e8-91cd-968165c23870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-6b80-70e8-91cd-968165c23870",
        "storage_key": "property/6737460151191759/019e1e48-6b80-70e8-91cd-968165c23870.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmonturgentcare.org/locations/macon-zebulon-ga?location=173&utm_source=rioseo&utm_medium=local&utm_content=clinic_link_173",
      "poi_directions_map_url": "https://maps.google.com/?cid=7838489467053567790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-urgent-care",
      "poi_latitude": "32.8803634",
      "poi_longitude": "-83.7542953",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-787-0410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_U4mi73584gRLm9e46Pox2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f42c2423-9aff-40f8-9710-c62c552f8ae3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Atrium Health Navicent Wellness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3797 Northside Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-6ec7-76df-bf26-3218bbbcf75c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-6ec7-76df-bf26-3218bbbcf75c",
        "storage_key": "property/6737460151191759/019e1e48-6ec7-76df-bf26-3218bbbcf75c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://navicenthealth.org/service-center/wellness-center?utm_source=GMB&utm_medium=Organic&utm_campaign=AHN",
      "poi_directions_map_url": "https://maps.google.com/?cid=8161841097392434994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-navicent-wellness-center",
      "poi_latitude": "32.8987922",
      "poi_longitude": "-83.6926345",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 478-477-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUpcxLj484gRMq9CGzyvRHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wellness_center"
    },
    {
      "id": "custom_0fd52c2d-58b1-4eac-96d7-e57f3c649f5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "160 Tom Hill Sr Blvd, Macon, GA 31210, USA",
      "poi_short_description": "Members-only chain fitness center offering equipment, massage chairs, and tanning beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-858f-73aa-99ef-64ab7fac0057.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-858f-73aa-99ef-64ab7fac0057",
        "storage_key": "property/6737460151191759/019e1e46-858f-73aa-99ef-64ab7fac0057.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/macon-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4452583688016435449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.8999575",
      "poi_longitude": "-83.6907913",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 478-254-8970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7aXCbj484gR-RjrAEbByj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8808cbe1-8261-4848-9210-b60fac341193",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "MVP Physio Dr.",
      "poi_type": "Health and Wellness",
      "poi_address": "1645 Forest Hill Rd Suite 105, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7adc-76e2-a838-a69fe0e4dd66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7adc-76e2-a838-a69fe0e4dd66",
        "storage_key": "property/6737460151191759/019e1e48-7adc-76e2-a838-a69fe0e4dd66.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mvpphysiodr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1482616609942772973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mvp-physio-dr",
      "poi_latitude": "32.900583",
      "poi_longitude": "-83.70298749999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 478-960-7077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQVk-Vv784gR7Zy7lfNPkxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_64bb36f2-631d-4ef5-8e33-a8496ae92ac4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1615 Forest Hill Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-70a5-75d8-84bc-f46cddeaa8ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-70a5-75d8-84bc-f46cddeaa8ee",
        "storage_key": "property/6737460151191759/019e1e48-70a5-75d8-84bc-f46cddeaa8ee.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/macon-ga-pharmacies/1615-forest-hill-rd-macon-ga-31210/storeid=4545?WT.mc_id=LS_GOOGLE_RX_4545",
      "poi_directions_map_url": "https://maps.google.com/?cid=14443882509463179468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8997442",
      "poi_longitude": "-83.7028067",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-477-6648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-932d-7048-b9b3-11007ddef3c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-932d-7048-b9b3-11007ddef3c9",
        "storage_key": "property/6737460151191759/019e1e48-932d-7048-b9b3-11007ddef3c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQTvhlJT484gRzNAHip36csg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_25de63f1-3293-424b-9f94-0c12c01429f0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5928 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7098-7009-b5db-eaaa20a74f13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7098-7009-b5db-eaaa20a74f13",
        "storage_key": "property/6737460151191759/019e1e48-7098-7009-b5db-eaaa20a74f13.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/011/00425?cid=loc_01100425P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15660966136556005807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "32.8779586",
      "poi_longitude": "-83.7602323",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-757-4152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-932d-7048-b9b3-11007ddef3c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-932d-7048-b9b3-11007ddef3c9",
        "storage_key": "property/6737460151191759/019e1e48-932d-7048-b9b3-11007ddef3c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QktLNX584gRr6nX0LntVtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_216f9127-7ed6-48b1-8a45-139922b1868e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Cor Studio - Pilates, Yoga, Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "4524 Forsyth Rd #103, Macon, GA 31210, USA",
      "poi_short_description": "Boutique studio specializing in yoga, barre and Pilates mat classes, plus individual sessions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7252-72dd-a6f1-6b1a2d79f37f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7252-72dd-a6f1-6b1a2d79f37f",
        "storage_key": "property/6737460151191759/019e1e48-7252-72dd-a6f1-6b1a2d79f37f.webp",
        "width": 1179,
        "height": 1280
      },
      "poi_business_url": "http://corstudiomacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12037224492430158599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cor-studio---pilates-yoga-barre",
      "poi_latitude": "32.8715535",
      "poi_longitude": "-83.70517579999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-283-3121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVUpcxLj484gRB2vuYObPDKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f36833a9-0e5e-473e-ad2e-996c7059cdcb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "4420 Forsyth Rd Suite 140, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-717d-700b-b553-a70b1f172a5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-717d-700b-b553-a70b1f172a5c",
        "storage_key": "property/6737460151191759/019e1e48-717d-700b-b553-a70b1f172a5c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/macon-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=5588035193344403738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "32.8685408",
      "poi_longitude": "-83.7000181",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-757-8561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ84uBtxj584gRGqms02awjE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_97df30de-f939-4322-971b-b013f7d445a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Amerson River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2551 Pierce Dr N, Macon, GA 31204, USA",
      "poi_short_description": "This sprawling park with woods, wetlands & meadows offers a playground, canoe launch & trails.",
      "poi_long_description": "This sprawling park with woods, wetlands & meadows offers a playground, canoe launch & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-8f19-738f-8e08-2003e152de29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-8f19-738f-8e08-2003e152de29",
        "storage_key": "property/6737460151191759/019e1e46-8f19-738f-8e08-2003e152de29.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "http://maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6348967655751333775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amerson-river-park",
      "poi_latitude": "32.8742247",
      "poi_longitude": "-83.6571728",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-803-0484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6f-73d2-97e2-da99aef2440e",
        "storage_key": "property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRY3JciD_84gRj7eA03EQHFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_657c3b74-ef9e-4954-8c47-6becddca570f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Museum of Arts and Sciences",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4182 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "Museum featuring fine-arts & science galleries, interactive exhibits, a minizoo & a planetarium.",
      "poi_long_description": "Museum featuring fine-arts & science galleries, interactive exhibits, a minizoo & a planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-847b-71fc-a6ac-f20b185dfd59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-847b-71fc-a6ac-f20b185dfd59",
        "storage_key": "property/6737460151191759/019e1e46-847b-71fc-a6ac-f20b185dfd59.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.masmacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10200504975877659134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-arts-and-sciences",
      "poi_latitude": "32.8648216",
      "poi_longitude": "-83.695182",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-477-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d37-70dc-bcf3-4aaf880a148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d37-70dc-bcf3-4aaf880a148e",
        "storage_key": "property/6737460151191759/019e1e46-9d37-70dc-bcf3-4aaf880a148e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_E6OCP584gR_tnKIDt5j40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a28ffbd9-f85c-45da-b44a-c615765ad7cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Wesleyan Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4760 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7444-7472-af2e-31838f3d9f67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7444-7472-af2e-31838f3d9f67",
        "storage_key": "property/6737460151191759/019e1e48-7444-7472-af2e-31838f3d9f67.webp",
        "width": 1280,
        "height": 1171
      },
      "poi_business_url": "https://www.wesleyancollege.edu/community/Arboretum/arboretum-home-page.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=8442985168664178042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wesleyan-arboretum",
      "poi_latitude": "32.8730649",
      "poi_longitude": "-83.71962669999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJARxfYgD584gReq0eLkeCK3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_7c70e689-1cf3-4a42-b7f6-83c0e6913dac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Ocmulgee Mounds National Historical Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1207 Emery Hwy, Macon, GA 31217, USA",
      "poi_short_description": "Historic park boasts Native American ceremonial earth mounds & a museum with artifacts on display.",
      "poi_long_description": "Historic park boasts Native American ceremonial earth mounds & a museum with artifacts on display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-6f70-73dc-bc44-7909396d8f68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-6f70-73dc-bc44-7909396d8f68",
        "storage_key": "property/6737460151191759/019e1e48-6f70-73dc-bc44-7909396d8f68.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.nps.gov/ocmu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1067029869745100363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ocmulgee-mounds-national-historical-park",
      "poi_latitude": "32.8381287",
      "poi_longitude": "-83.6020624",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-752-8257",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSV4UTxf-84gRS1bjXgPazg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_f8089ef0-14d4-4e58-a870-9d2f8b40a105",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Carolyn Crayton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "150 Willie Smokie Glover Dr, Macon, GA 31201, USA",
      "poi_short_description": "Venerable park with grills, picnic shelters, playgrounds, a gazebo & annual cherry-blossom festival.",
      "poi_long_description": "Venerable park with grills, picnic shelters, playgrounds, a gazebo & annual cherry-blossom festival.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-76d8-7004-a1bf-b5121e61ca3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-76d8-7004-a1bf-b5121e61ca3f",
        "storage_key": "property/6737460151191759/019e1e48-76d8-7004-a1bf-b5121e61ca3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maconbibb.us/recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9038425699568800054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carolyn-crayton-park",
      "poi_latitude": "32.8331789",
      "poi_longitude": "-83.6152137",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-621-6280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6f-73d2-97e2-da99aef2440e",
        "storage_key": "property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJU9CFAv-84gRNlGPP0nwbn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_754841f4-874e-4ae3-9789-d9318c5a9639",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Tattnall Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1155 College St, Macon, GA 31201, USA",
      "poi_short_description": "City park with a playing field, playground, picnic areas & tennis courts, known for cultural events.",
      "poi_long_description": "City park with a playing field, playground, picnic areas & tennis courts, known for cultural events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7542-76b8-ae2b-8b678cc439b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7542-76b8-ae2b-8b678cc439b9",
        "storage_key": "property/6737460151191759/019e1e48-7542-76b8-ae2b-8b678cc439b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.maconbibb.us/recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2052102277676605321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tattnall-square-park",
      "poi_latitude": "32.8332856",
      "poi_longitude": "-83.6469206",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-219-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6f-73d2-97e2-da99aef2440e",
        "storage_key": "property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-8Jn5z-84gRiR-vJyaIehw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_de790419-7b21-479e-8150-ee38a617717f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Coleman Hill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "285 Spring St, Macon, GA 31201, USA",
      "poi_short_description": "Park featuring concrete slides for adults and children, plus views of downtown.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-78df-77f2-ae19-f12211ae9eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-78df-77f2-ae19-f12211ae9eb6",
        "storage_key": "property/6737460151191759/019e1e48-78df-77f2-ae19-f12211ae9eb6.webp",
        "width": 1200,
        "height": 770
      },
      "poi_business_url": "http://www.maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1357070185767298207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coleman-hill-park",
      "poi_latitude": "32.8413761",
      "poi_longitude": "-83.6333465",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-621-6280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6f-73d2-97e2-da99aef2440e",
        "storage_key": "property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0D3W2L-84gRn-Tu1SRI1RI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_053e6c87-6118-4b71-9243-c371b5bedf21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Macon Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "831 Adams St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7aee-77ec-9a6a-1db0feb0f2af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7aee-77ec-9a6a-1db0feb0f2af",
        "storage_key": "property/6737460151191759/019e1e48-7aee-77ec-9a6a-1db0feb0f2af.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.maconbibb.us/recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15534550482631304007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-dog-park",
      "poi_latitude": "32.8371029",
      "poi_longitude": "-83.6459818",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-621-6280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6f-73d2-97e2-da99aef2440e",
        "storage_key": "property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJETepz5r-84gRR6OcvlvPldc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_5da98e15-293b-4176-ad4e-f01171a02a0e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Lake Tobesofkee Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6600 Moseley Dixon Rd, Lizella, GA 31052, USA",
      "poi_short_description": "Destination for camping, boating, fishing & swimming with 3 sandy beaches & play areas for kids.",
      "poi_long_description": "Destination for camping, boating, fishing & swimming with 3 sandy beaches & play areas for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-80a9-779c-8a6a-be1c00318064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-80a9-779c-8a6a-be1c00318064",
        "storage_key": "property/6737460151191759/019e1e48-80a9-779c-8a6a-be1c00318064.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://laketobo.maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14823284184662501318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-tobesofkee-recreation-area",
      "poi_latitude": "32.8272218",
      "poi_longitude": "-83.7743509",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 478-474-8770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6f-73d2-97e2-da99aef2440e",
        "storage_key": "property/6737460151191759/019e1e46-9d6f-73d2-97e2-da99aef2440e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Z9TVrLw84gRxmd5x23its0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8e68c529-40e6-4ddd-8fc8-eb8769fdab14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Macon-Bibb County Transit Authority and Macon Terminal Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 Cherry St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7f8f-7126-8ded-bdf3abd9a265.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7f8f-7126-8ded-bdf3abd9a265",
        "storage_key": "property/6737460151191759/019e1e48-7f8f-7126-8ded-bdf3abd9a265.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.mta-mac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237011634625982985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-bibb-county-transit-authority-and-macon-terminal-station",
      "poi_latitude": "32.8337611",
      "poi_longitude": "-83.62413",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-803-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-9330-74a8-b06a-c726d0e38187.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-9330-74a8-b06a-c726d0e38187",
        "storage_key": "property/6737460151191759/019e1e48-9330-74a8-b06a-c726d0e38187.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJad5y1Xb-84gRCTLoGIe_KhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_9de8dfc8-921f-4c0c-ac77-6e647040ccb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Middle Georgia Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1000 Terminal Dr, Macon, GA 31297, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7c54-753a-ac21-b96182ac1926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7c54-753a-ac21-b96182ac1926",
        "storage_key": "property/6737460151191759/019e1e48-7c54-753a-ac21-b96182ac1926.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://iflymacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15662957178268972092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-georgia-regional-airport",
      "poi_latitude": "32.7018947",
      "poi_longitude": "-83.6502227",
      "poi_miles_from_property": "18",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 478-219-1138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-9308-76fe-b6bc-a64369edb3e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-9308-76fe-b6bc-a64369edb3e6",
        "storage_key": "property/6737460151191759/019e1e48-9308-76fe-b6bc-a64369edb3e6.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78hrbw7j84gRPHTgVpEAXtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7ec09af2-d59f-4e82-b6ff-f42f45ce6dbd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Mercer University",
      "poi_type": "Transportation & Transit",
      "poi_address": "1501 Mercer University Dr, Macon, GA 31207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-5d1d-733d-b9f8-e63effc30212.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-5d1d-733d-b9f8-e63effc30212",
        "storage_key": "property/6737460151191759/019e1e48-5d1d-733d-b9f8-e63effc30212.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mercer.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11661349141602039264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercer-university",
      "poi_latitude": "32.8284878",
      "poi_longitude": "-83.64969909999999",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-637-2378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS4T9n4n-84gR4PX-gkJv1aE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2631e202-2aac-4dab-b6f5-7658f812d516",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Hampton Inn & Suites Macon I-75 North",
      "poi_type": "Transportation & Transit",
      "poi_address": "3954 River Pl Dr, Macon, GA 31210, USA",
      "poi_short_description": "Straightforward rooms in a riverside hotel with a pool & a gym, plus free Wi-Fi & hot breakfast.",
      "poi_long_description": "Straightforward rooms in a riverside hotel with a pool & a gym, plus free Wi-Fi & hot breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-7fef-771c-beb2-c0b0857050da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-7fef-771c-beb2-c0b0857050da",
        "storage_key": "property/6737460151191759/019e1e48-7fef-771c-beb2-c0b0857050da.webp",
        "width": 1023,
        "height": 682
      },
      "poi_business_url": "https://www.hilton.com/en/hotels/mcnnohx-hampton-suites-macon-i-75-north/?SEO_id=GMB-AMER-HX-MCNNOHX&y_source=1_MjA4Mzk0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8717092486049774034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampton-inn--suites-macon-i-75-north",
      "poi_latitude": "32.9035017",
      "poi_longitude": "-83.6831524",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-803-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-932e-75d8-8338-776da9d59698.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-932e-75d8-8338-776da9d59698",
        "storage_key": "property/6737460151191759/019e1e48-932e-75d8-8338-776da9d59698.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJlYdsWrH484gR0jk5UW5V-Xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_9a0d511c-ac36-47a6-b995-742004f47551",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Macon Coliseum",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 Coliseum Dr, Macon, GA 31217, USA",
      "poi_short_description": "Concerts, comedy, ice skating & family shows are held in this 9,252-seat coliseum built in 1968.",
      "poi_long_description": "Concerts, comedy, ice skating & family shows are held in this 9,252-seat coliseum built in 1968.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-81d3-740a-b9df-d23d632b368d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-81d3-740a-b9df-d23d632b368d",
        "storage_key": "property/6737460151191759/019e1e48-81d3-740a-b9df-d23d632b368d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.maconcentreplex.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12629966363785601746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-coliseum",
      "poi_latitude": "32.8422055",
      "poi_longitude": "-83.6195796",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-803-1593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSUTlWv-84gR0qKSzn2nRq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_1af567d2-4e0d-4179-8363-e1c02d18fd33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Macon Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 Cherry St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-81e6-776e-a188-7363df6c7698.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-81e6-776e-a188-7363df6c7698",
        "storage_key": "property/6737460151191759/019e1e48-81e6-776e-a188-7363df6c7698.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://locations.greyhound.com/bus-stations/US/Macon/bus-station/bus-station-410685?utm_source=google&utm_medium=distrib&utm_campaign=google-distrib",
      "poi_directions_map_url": "https://maps.google.com/?cid=16615137765667952925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-bus-station",
      "poi_latitude": "32.8331913",
      "poi_longitude": "-83.6247348",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-743-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQ0RVmH-84gRHdnQYMTTlOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_eb34057c-b8f6-4244-93f9-b23a552c3462",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Atrium Health Navicent The Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "777 Hemlock St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-847e-73fd-ac91-3448dbbb16ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-847e-73fd-ac91-3448dbbb16ae",
        "storage_key": "property/6737460151191759/019e1e48-847e-73fd-ac91-3448dbbb16ae.webp",
        "width": 1091,
        "height": 614
      },
      "poi_business_url": "https://navicenthealth.org/service-center/the-medical-center?utm_source=GMB&utm_medium=Organic&utm_campaign=AHN",
      "poi_directions_map_url": "https://maps.google.com/?cid=5959506398997543211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-navicent-the-medical-center",
      "poi_latitude": "32.8338321",
      "poi_longitude": "-83.6365537",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-633-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d2c-77b0-822e-cbb9ee401211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d2c-77b0-822e-cbb9ee401211",
        "storage_key": "property/6737460151191759/019e1e46-9d2c-77b0-822e-cbb9ee401211.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJccj0KX7-84gRK3nqvH5rtFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_23b60a7b-1505-4f0c-b7e0-2ea40879759c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Piedmont Macon North",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 Charter Blvd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-8e39-77fb-a9d6-f0ad001e69f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-8e39-77fb-a9d6-f0ad001e69f1",
        "storage_key": "property/6737460151191759/019e1e46-8e39-77fb-a9d6-f0ad001e69f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-macon-north-hospital?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MjY4OTU4OTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17716511181231489673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-macon-north",
      "poi_latitude": "32.8715199",
      "poi_longitude": "-83.6945317",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-757-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d2c-77b0-822e-cbb9ee401211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d2c-77b0-822e-cbb9ee401211",
        "storage_key": "property/6737460151191759/019e1e46-9d2c-77b0-822e-cbb9ee401211.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ35QKcSP584gRiQKKoA2x3fU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_63aa008a-2d6c-4783-9440-6871671f645c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Piedmont Macon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "350 Hospital Dr, Macon, GA 31217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-8627-72ba-8602-e7a4981ee2de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-8627-72ba-8602-e7a4981ee2de",
        "storage_key": "property/6737460151191759/019e1e48-8627-72ba-8602-e7a4981ee2de.webp",
        "width": 1195,
        "height": 672
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-macon-medical-center?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MjY4OTU4OTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10547206693762299691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-macon",
      "poi_latitude": "32.8473009",
      "poi_longitude": "-83.618713",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-765-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d2c-77b0-822e-cbb9ee401211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d2c-77b0-822e-cbb9ee401211",
        "storage_key": "property/6737460151191759/019e1e46-9d2c-77b0-822e-cbb9ee401211.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJhYCxJGr-84gRK_dSQps0X5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9639827c-eeb6-4371-9cda-0c33f3415f44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Middle Georgia State University - Macon Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 University Pkwy, Macon, GA 31206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-85dc-768c-a46b-71d7c2525fbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-85dc-768c-a46b-71d7c2525fbf",
        "storage_key": "property/6737460151191759/019e1e48-85dc-768c-a46b-71d7c2525fbf.webp",
        "width": 600,
        "height": 337
      },
      "poi_business_url": "https://www.mga.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021359213706895153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-georgia-state-university---macon-campus",
      "poi_latitude": "32.8109077",
      "poi_longitude": "-83.7326161",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 478-471-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d28-7596-be07-0f37fd00c71a",
        "storage_key": "property/6737460151191759/019e1e46-9d28-7596-be07-0f37fd00c71a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkX-PZwD784gRMV8moerflcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dd9a18d4-ec1d-4025-ade3-0913288f1ea2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Norfolk Southern Brosnan Yard",
      "poi_type": "Major Employers & Offices",
      "poi_address": "355 Turpin St, Macon, GA 31206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-86ef-7255-a5d3-0a27bc1b578b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-86ef-7255-a5d3-0a27bc1b578b",
        "storage_key": "property/6737460151191759/019e1e48-86ef-7255-a5d3-0a27bc1b578b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5617468484333425671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norfolk-southern-brosnan-yard",
      "poi_latitude": "32.8209866",
      "poi_longitude": "-83.6253081",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 478-743-8380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0oitdD984gRB1Sl6dJB9U0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_926ecdf6-e662-4277-b37a-3c5c56a4fdb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "GEICO Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4295 Ocmulgee E Blvd, Macon, GA 31295, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-86b1-7269-8850-70151b214ba2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-86b1-7269-8850-70151b214ba2",
        "storage_key": "property/6737460151191759/019e1e48-86b1-7269-8850-70151b214ba2.webp",
        "width": 1085,
        "height": 1280
      },
      "poi_business_url": "https://www.geico.com/?y_source=1_MTQ5NTQ4MDktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13054691806611906697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "geico-corporate-office",
      "poi_latitude": "32.809451",
      "poi_longitude": "-83.57070879999999",
      "poi_miles_from_property": "14.1",
      "poi_walking_minutes": "5 hours 13 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-741-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlV2BJRNW8YgRiSBOCQiVK7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_755520f7-0c6f-4309-a696-6e07871bc5d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "YKK AP America Inc. (Residential Windows)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 YKK AP Wy, Macon, GA 31216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-87c3-7448-8b49-f6c5faa99898.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-87c3-7448-8b49-f6c5faa99898",
        "storage_key": "property/6737460151191759/019e1e48-87c3-7448-8b49-f6c5faa99898.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ykkap.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6864702201200601390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ykk-ap-america-inc-residential-windows",
      "poi_latitude": "32.8118934",
      "poi_longitude": "-83.5674591",
      "poi_miles_from_property": "14",
      "poi_walking_minutes": "5 hours 10 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 866-348-9091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdlcCm1W8YgRLmln_0dSRF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_964b2006-76ba-437a-ad9b-64c4fc853f64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Graphic Packaging International Macon GA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Graphic Pkg, Macon, GA 31206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-8c1d-713a-9cc9-73429ec07f23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-8c1d-713a-9cc9-73429ec07f23",
        "storage_key": "property/6737460151191759/019e1e48-8c1d-713a-9cc9-73429ec07f23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.graphicpkg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5143895376103681438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "graphic-packaging-international-macon-ga",
      "poi_latitude": "32.7738532",
      "poi_longitude": "-83.6307963",
      "poi_miles_from_property": "13.5",
      "poi_walking_minutes": "4 hours 59 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 478-788-6160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-9d6d-7429-8eee-c246a799e22a",
        "storage_key": "property/6737460151191759/019e1e46-9d6d-7429-8eee-c246a799e22a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT8c1Zx7984gRni1vTpfJYkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_a7379299-bd55-4f99-9db0-b390b2effc3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "poi_name": "Macon-Bibb County Government Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 Poplar St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-8c58-72cf-ae63-59c1fa4cbb08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e48-8c58-72cf-ae63-59c1fa4cbb08",
        "storage_key": "property/6737460151191759/019e1e48-8c58-72cf-ae63-59c1fa4cbb08.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15610024968312878462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-bibb-county-government-center",
      "poi_latitude": "32.8360042",
      "poi_longitude": "-83.6322394",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-751-7170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e1e48-9330-74a8-b06a-c726d0e38187.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e48-9330-74a8-b06a-c726d0e38187",
        "storage_key": "property/6737460151191759/019e1e48-9330-74a8-b06a-c726d0e38187.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE5oe-3z-84gRfnVE0wDzodg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7c0833cfdddd7b35b60d79a7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3c59a8329009daae657b79b0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1c35f3cbd5ae04125d084467",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_232047264918d4042a99bfa1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_668e5fd01bcda4aa9af1d40a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d117c58e4d5843fd95d7fdaa",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1990fda7-a2cf-4a27-bc71-8e83c3f2d72f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "rating": "5.0",
      "name": "Lewis Tof",
      "text": "Thank you for all your help Darreyas! My new toilet is working great.",
      "date": "2026-05-28",
      "title": ""
    },
    {
      "id": "custom_a0f994d1-9e40-4712-83d8-0498faaa6dc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "rating": "5.0",
      "name": "Charles Riley",
      "text": "Thank you for kitchen light and filter Darreyas!",
      "date": "2026-05-28",
      "title": ""
    },
    {
      "id": "custom_f76eb6b4-e8ad-4536-b94b-04ec49d47c63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "rating": "5",
      "name": "Coolchosen1",
      "text": "Put in a service request 5/27/2026 and Darius came right out the next morning and took care of it. My air conditioner was not working and it’s hot in the apartment. I’ve got cool air now!! Thanks Darius…💝🙏🏽✌🏾",
      "date": "2026-05-28",
      "title": "false"
    },
    {
      "id": "custom_23c6ec71-2a4c-4285-9b74-20618a75a0b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "rating": "5",
      "name": "Accura Denmark",
      "text": "Excellent service and speedy process - Darius",
      "date": "2026-05-22",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_eef3bafc-acae-4fc1-aa3a-f73d77114cd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019e4266-c411-750b-b246-4da60cff0077.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4266-c411-750b-b246-4da60cff0077",
        "storage_key": "property/6737460151191759/019e4266-c411-750b-b246-4da60cff0077.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=66c4f63fbd63ff028611c7a1"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e45-b990-7749-88bb-48c6afcabbbb",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-falls-at-spring-creek-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759"
    },
    {
      "lead_collector_id": "01996477-3b63-726c-9d52-2b1fe2a1218e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-falls-at-spring-creek-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-macon-ga",
      "search_query": "luxury apartments with pool Macon GA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Macon, GA",
      "h2_subtitle": "Discover Falls at Spring Creek's premium living. Our luxury apartments offer a pool and more in the vibrant heart of Macon, GA.",
      "page_copy": "Experience the pinnacle of luxury living at Falls at Spring Creek, where our apartments promise an unparalleled lifestyle in Macon, GA. Nestled within a lively community, our residences boast exquisite design and modern comforts to satisfy all tastes. Enjoy spacious one, two, and three-bedroom floor plans that cater to your lifestyle needs, paired with elegant touches like stainless steel appliances and walk-in closets.\n\nOur resort-style amenities shine with our refreshing pool, perfect for unwinding on a warm Georgia day. Additionally, residents have access to a state-of-the-art fitness center and a welcoming clubhouse that fosters a community atmosphere. With the added convenience of maintenance on-site, find a haven at Falls at Spring Creek, your top choice for luxury apartments with a pool in Macon, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
        "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Macon, GA",
      "seo_description": "Falls at Spring Creek offers luxury apartments with a pool in Macon, GA. Discover premium living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-bibb-county",
      "search_query": "fitness center apartments in Bibb County",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Bibb County",
      "h2_subtitle": "Explore Falls at Spring Creek, where fitness and comfort meet. Our Bibb County apartments feature a state-of-the-art fitness center.",
      "page_copy": "At Falls at Spring Creek, we redefine apartment living in Bibb County, with our focus on fitness and a healthy lifestyle. Our modern fitness center is designed to cater to all workout preferences, offering residents the convenience of maintaining their health right at home. Whether you're lifting weights or doing cardio, our facilities accommodate every exercise routine.\n\nBeyond the gym, residents of Falls at Spring Creek enjoy a suite of amenities including a refreshing pool and a welcoming clubhouse. Our spacious floor plans—available as one, two, or three-bedroom layouts—are designed with comfort in mind, featuring walk-in closets and stainless steel appliances. Discover a community where luxury meets health at Falls at Spring Creek in Bibb County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
        "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Bibb County",
      "seo_description": "Discover Falls at Spring Creek with a fitness center. Premier Bibb County apartments for a balanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "generator",
      "page_item_url": "gated-community-apartments-macon-31210",
      "search_query": "gated community apartments Macon 31210",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Macon 31210",
      "h2_subtitle": "Falls at Spring Creek offers secure living. Experience peace of mind in our gated community in Macon, GA 31210.",
      "page_copy": "Enjoy the privacy and security of gated community living at Falls at Spring Creek, ideally located in Macon, GA, within the 31210 zip code. Our community provides residents with a serene environment where you can feel safe and secure. Alongside our controlled access, we offer spacious one, two, and three-bedroom apartments designed for contemporary living.\n\nFalls at Spring Creek boasts a suite of luxury amenities designed to enhance your lifestyle. Relax by our shimmering pool, stay active in our state-of-the-art fitness center, or connect with neighbors in our inviting clubhouse. With additional features like stainless steel appliances and walk-in closets, living in a gated community has never been more appealing. Make Falls at Spring Creek your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
        "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in Macon 31210",
      "seo_description": "Falls at Spring Creek offers gated community living in Macon, GA 31210. Discover a secure and luxurious lifestyle today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-macon",
      "search_query": "apartments with in-unit laundry Macon",
      "category": "Amenity",
      "h1_title": "Macon Apartments with In-Unit Laundry",
      "h2_subtitle": "Falls at Spring Creek offers the convenience of in-unit laundry. Enjoy modern living in our Macon apartments.",
      "page_copy": "Discover the convenience of in-unit laundry at Falls at Spring Creek, where your comfort is our priority. Located in the vibrant city of Macon, GA, our apartments provide all the modern luxuries you expect, including the seamless convenience of doing laundry in the privacy of your own home. Enjoy other thoughtfully designed features such as walk-in closets and stainless steel appliances, making day-to-day life effortlessly comfortable.\n\nBeyond the interiors, our community is brimming with amenities that enhance your lifestyle. Dive into relaxation at our resort-style pool, maintain your fitness in our well-equipped gym, or engage with the community in our welcoming clubhouse. Falls at Spring Creek in Macon is not just a place to live—it's a place to thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
        "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Macon Apartments with In-Unit Laundry",
      "seo_description": "Experience modern living in Macon apartments with in-unit laundry at Falls at Spring Creek. Enjoy convenience and comfort in every unit.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-near-bibb-county",
      "search_query": "pet friendly apartments near Bibb County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments Near Bibb County",
      "h2_subtitle": "Welcome to Falls at Spring Creek, a haven for pet lovers. Our community near Bibb County offers an ideal setting for pets and their owners.",
      "page_copy": "At Falls at Spring Creek, we understand that pets are family. Nestled close to Bibb County, our pet-friendly apartments offer the perfect environment for you and your furry companions. Our spacious floor plans provide ample room for pets to play and stretch out, while our beautifully landscaped grounds offer the ideal setting for walks and outdoor activities within the community.\n\nOur amenities cater not only to humans but also to pets, ensuring a happy home for everyone. As residents, you will enjoy luxurious living with features such as walk-in closets, stainless steel appliances, and a modern fitness center. Plus, our inviting clubhouse and pool provide great spaces for socializing, both for you and your pet. Make Falls at Spring Creek your newest pet-friendly home near Bibb County today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
        "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Bibb County",
      "seo_description": "Find pet-friendly bliss at Falls at Spring Creek, near Bibb County. Spacious homes and amenities welcome you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-macon-ga",
      "search_query": "one bedroom apartments macon ga",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Macon, GA",
      "h2_subtitle": "Discover spacious one-bedroom apartments at Falls at Spring Creek in Macon, GA. Perfect for modern living!",
      "page_copy": "Looking for a perfect one-bedroom apartment in Macon, GA? Falls at Spring Creek offers beautifully designed units that cater to all your needs. Our one-bedroom floor plans are spacious and thoughtfully laid out, providing a comfortable living environment in the heart of Macon. Featuring high-end finishes such as stainless steel appliances and generous walk-in closets, our apartments meet the demand for quality and convenience.\n\nIn addition to the well-appointed interiors, residents can enjoy an array of luxurious community amenities. Take a dip in our refreshing pool, stay active in our modern fitness center, or relax in our welcoming clubhouse. With maintenance on-site and features like screened-in lanais available, you’ll love calling Falls at Spring Creek home. Schedule a tour today to see our one-bedroom offerings in Macon, GA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
        "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Macon, GA",
      "seo_description": "Explore spacious one-bedroom apartments at Falls at Spring Creek in Macon, GA. Enjoy modern amenities and luxurious living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-bibb-county",
      "search_query": "two bedroom apartments in bibb county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Bibb County",
      "h2_subtitle": "Explore two-bedroom apartments at Falls at Spring Creek, located in Bibb County. Enjoy spacious living with premium amenities.",
      "page_copy": "If you are searching for a two-bedroom apartment in Bibb County, look no further than Falls at Spring Creek. Our community offers spacious two-bedroom units perfect for families or roommates seeking comfort and style. Each apartment features contemporary finishes like stainless steel appliances and generous walk-in closets, ensuring a sleek and organized living space for all.\n\nIn addition to our well-designed interiors, Falls at Spring Creek provides a host of resort-style amenities. Our residents enjoy the tranquility of our refreshing pool, the convenience of a fitness center with 24-hour access, and the social opportunities offered by our welcoming clubhouse. With our convenient location in Bibb County, you can experience the perfect blend of comfort and community. Contact us today to explore our two-bedroom options!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
        "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Bibb County",
      "seo_description": "Find your ideal two-bedroom apartment at Falls at Spring Creek in Bibb County. Enjoy spacious living and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191759",
      "source": "generator",
      "page_item_url": "three-bedroom-floorplans-near-31210",
      "search_query": "three bedroom floorplans near 31210",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floorplans Near 31210",
      "h2_subtitle": "Discover spacious three-bedroom floorplans at Falls at Spring Creek, conveniently located near 31210. Perfect for families!",
      "page_copy": "If you're searching for expansive three-bedroom floorplans near the 31210 area, Falls at Spring Creek is the community you’ve been looking for. Our thoughtfully designed apartments provide ample space for families or those needing extra room, featuring modern amenities like stainless steel appliances and walk-in closets. \n\nApart from our luxurious units, Falls at Spring Creek offers an impressive range of community features. Residents can enjoy the sun by our refreshing pool, stay fit with our 24/7 accessible fitness center, or host gatherings in our inviting clubhouse. Situated in the heart of Macon, our community provides easy access to everyday conveniences, making it an ideal choice for anyone seeking comfort and convenience close to the 31210 vicinity. Visit us today to view these exceptional three-bedroom floorplans!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "019d076e-25e8-7709-accd-71ef24df3177",
        "storage_key": "property/6737460151191759/019d076e-25e8-7709-accd-71ef24df3177.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floorplans Near 31210",
      "seo_description": "Explore spacious three-bedroom floorplans at Falls at Spring Creek near 31210. Enjoy modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3350"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483326"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4857247"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-ML6C2FQH"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "478-606-1634"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "478-606-1681"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "478-606-1644"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "478-606-1492"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "478-606-1718"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "478-606-1432"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "478-606-1695"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "478-606-1700"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "478-606-1689"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "478-249-4717"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "478-249-7462"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "478-606-1603"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "478-312-5404"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "478-221-7231"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "478-236-6571"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "478-606-2190"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "478-606-1908"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "478-217-7958"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321147659"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "478-606-1701"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "478-375-4807"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "de1ea159711eee08"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "478-822-4814"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "478-606-1632"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "478-606-1486"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "478-375-6235"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "478-606-1716"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "478-606-1437"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "478-606-1676"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.fallsatspringcreek.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191759/019e60e9-1870-778d-93f8-b937b3ca6247.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "478-606-1651"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "478-249-4717"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3350",
  "custom_repli_id": "5028483326",
  "custom_realpage_id": "4857247",
  "custom_knock_a_link": "https://www.fallsatspringcreek.com?utm_knock=a",
  "custom_knock_g_link": "https://www.fallsatspringcreek.com?utm_knock=g",
  "custom_knock_r_link": "https://www.fallsatspringcreek.com?utm_knock=r",
  "custom_knock_w_link": "https://www.fallsatspringcreek.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-ML6C2FQH",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.fallsatspringcreek.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.fallsatspringcreek.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.fallsatspringcreek.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.fallsatspringcreek.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.fallsatspringcreek.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.fallsatspringcreek.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "478-606-1634",
  "custom_knock_ads_link": "https://www.fallsatspringcreek.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.fallsatspringcreek.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "478-606-1681",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.fallsatspringcreek.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.fallsatspringcreek.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.fallsatspringcreek.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.fallsatspringcreek.com?utm_knock=psa",
  "custom_knock_r_number": "478-606-1644",
  "custom_knock_w_number": "478-606-1492",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "478-606-1718",
  "custom_knock_amap_link": "https://www.fallsatspringcreek.com?utm_knock=amap",
  "custom_knock_ar_number": "478-606-1432",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "478-606-1695",
  "custom_knock_fb_number": "478-606-1700",
  "custom_knock_fl_number": "478-606-1689",
  "custom_knock_gp_number": "478-249-4717",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.fallsatspringcreek.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "478-249-7462",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.fallsatspringcreek.com?utm_knock=bcard",
  "custom_knock_bnr_number": "478-606-1603",
  "custom_knock_cfres_link": "https://www.fallsatspringcreek.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "478-312-5404",
  "custom_knock_lgp_number": "478-221-7231",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.fallsatspringcreek.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "478-236-6571",
  "custom_knock_psa_number": "478-606-2190",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "478-606-1908",
  "custom_knock_bandit_link": "https://www.fallsatspringcreek.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.fallsatspringcreek.com?utm_knock=flyers",
  "custom_knock_osoc_number": "478-217-7958",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321147659",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "478-606-1701",
  "custom_knock_cfres_number": "478-375-4807",
  "custom_knock_chatgpt_link": "https://www.fallsatspringcreek.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "de1ea159711eee08",
  "custom_knock_dirmail_link": "https://www.fallsatspringcreek.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "478-822-4814",
  "custom_knock_propbro_link": "https://www.fallsatspringcreek.com?utm_knock=propbro",
  "custom_knock_bandit_number": "478-606-1632",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "478-606-1486",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.fallsatspringcreek.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "478-375-6235",
  "custom_knock_dirmail_number": "478-606-1716",
  "custom_knock_propbro_number": "478-606-1437",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "478-606-1676",
  "custom_knock_maintenance_link": "https://www.fallsatspringcreek.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191759/019e60e9-1870-778d-93f8-b937b3ca6247.mp4",
  "custom_knock_maintenance_number": "478-606-1651",
  "custom_ppc_tracking_phone_number": "478-249-4717"
};

export const generatedAt = '2026-10-07T17:16:28.513Z';
